import React, { Component } from "react";
import { Form, Button, Image } from "react-bootstrap";
import { curry, get } from "lodash";
import IconFilter from "../../assets/filter-4.png";
import FilterIcon from "../../assets/filter-icon.png";
import {
  GET_PROJECT_LIST_ACTION,
  CLEAR_ISSUE_OLD_FILTERS_ACTION
} from "../../actions/projectList.action";
import request from "../../services/requestService";

import { connect } from "react-redux";
import { bindActionCreators } from "redux";
import { Link, Redirect } from "react-router-dom";
import { getProjectList } from "../../services/apiServices";
import {
  PATHS,
  STATUS,
  SORT_BY_FILTERS_LIST,
  PROJECT_AWARDED_BY,
  OTHER_CALENDER,
  archiveDropdown
} from "../../constant";
import {
  dateFormat,
  formatNumber,
  formatNumberOnDashBoard,
  getLocalstorage,
  isValidArray,
  scrollToPosition,
  setLocalstorage,
  transformProjectListPayload
} from "../../helper";
import DisplayByPermission from "../../component/DisplayByPermission";
import ProjectListLoader from "./ProjectListingWithLoader";
import LoaderTemplate from "../../component/LoaderTemplate";
import { FilterLoader } from "../../component/LoadersTemplate";
import PermissionHOC from "../PermissionHOC";
import FilterComponent from "../FilterComponent";
import { DownloadExcelReport, Search } from "../reusableComponent";
import { getProjectStakeHolderAction } from "../../actions/common.action";
import {
  getDownloadProjectListAction,
  clearProjectListDownloadAction
} from "../../actions/dowloadExcelActions";
import Pagination from "../Pagination";
import { SendByComponent } from "../sendNotification";
import { ProjectListHoc } from "./projectListHoc";
import CalendarFilter from "../calendarFilter/CalendarFilter";
import { SortBy } from "../reusableComponent";
import { ToggleBtn } from "../togglebtn";
import { getDraftedProjectDetails } from "../../actions/projectDetail.action";
import {
  getDashboardNotifications,
  getDashboardNotificationsAllViewed,
  getNotificationUpdates
} from "../../actions/dashboard.action";
import ResponsiveFilter from "../FilterComponent/ResponsiveFilter";
import { ModalIIGCreateProjectDisabled } from "../createProject/ModalIIGCreateProjectDisabled";
import { getGroupRolesForUser } from "../../actions/createProject.action";
import StateProjectsQuickFilter from "../FilterComponent/StateProjectsQuickFilter";
import QuickFilter from "../FilterComponent/QuickFilter";
import { Archive } from "../reusableComponent/archive";
class ProjectList extends Component {
  constructor(props) {
    super(props);
    const {
      location: { isDashBoard, summaryDataBy }
    } = props;

    const userSponsoredScheme = getLocalstorage("userSponsoredScheme");
    const summaryType = getLocalstorage("summaryType");
    const user = getLocalstorage("user");
    let _projectAwardedBy =
      user.groupCategory === "STATE_PMG"
        ? user.sponsoredScheme === "STATE" || summaryType === "SPONSOR"
        : isDashBoard
        ? isDashBoard && summaryDataBy
        : userSponsoredScheme;
    let _projectAwardedByDashboard =
      isDashBoard !== undefined &&
      getLocalstorage("stateAndCentralProjectSelectedBy") === "STATE" &&
      (user.groupCategory === "DISTRICT" ||
        user.groupCategory === "STATE_DEPARTMENT");

    this.state = {
      dates: {},
      isSearching: false,
      //projectAwardedBy: _projectAwardedBy || _projectAwardedByDashboard,
      projectAwardedBy: false,
      displayDateTitle: " - Created Date -",
      temporaryFilters: {
        offset: 0,
        limit: 10
      },
      userGroupInfo: null,
      showModalForCreateProjectDisabled: false,
      quickfilterdatanew: [
        "projectFlags",
        "projectTags",
        "projectStage",
        "sponsoringMinistry",
        "projectLocation",
        "projectImplementationMode",
        "projectZones"
      ],
      quickfilterdata_state: [
        "projectFlags",
        "projectTags",
        "projectStage",
        "sponsoringDepartment",
        "districtProjectLocation",
        "projectImplementationMode",
        "projectCost"
      ],
      Monitoringflagcurrent: [],
      ProjectStatuscurrent: [],
      ProjectStagecurrent: [],
      ProjectSponsoringMinistrycurrent: [],
      ProjectLocationcurrent: [],
      ImplementationModecurrent: [],
      ProjectZonecurrent: [],
      static_payload: {
        offset: 0,
        limit: 1,
        groupCategory: "CENTRAL",
        projectCost: [],
        delayedProject: [],
        costOverRun: []
      },
      static_payload_for_state: {
        offset: 0,
        limit: 1,
        groupCategory: "STATE",
        projectCost: [],
        delayedProject: [],
        issueAgeing: [],
        costOverRun: []
      },
      staticfilterdata: [],
      state_static_filter_data: [],
      projectZonekeys: [],
      QuickFilters: [
        // {
        //   key: "VERIFIED",
        //   displayName: "VERIFIED",
        //   count: 858,
        //   checked: true,
        //   filterName: "projectStage"
        // }
      ],
      underMaintenance: false,
      loading: true,
      Monitoringflag_State: [],
      ProjectStatus_State: [],
      ProjectStage_State: [],
      ProjectSponsoringDepartment_State: [],
      ImplementationMode_State: [],
      ProjectCost_State: [],
      ProjectDistrict_State: [],
      StateQuickFilters: []
    };
  }
  handleStateFilterChange = (updatedFilters, filterName) => {
    if (filterName == undefined) {
      const newData = [];
      newData.push(...updatedFilters);
      this.setState({ StateQuickFilters: newData }, () => {
        console.log(this.state.StateQuickFilters);
      });
    } else {
      const updatedData = updatedFilters.map(obj => ({
        ...obj,
        filterName: filterName
      }));
      const newData = [...this.state.StateQuickFilters];
      newData.push(...updatedData);
      this.setState({ StateQuickFilters: newData }, () => {
        console.log(this.state.StateQuickFilters);
      });
    }
  };
  handleFilterChange = (updatedFilters, filterName) => {
    if (filterName == undefined) {
      const newData = [];
      newData.push(...updatedFilters);
      this.setState({ QuickFilters: newData }, () => {
        //console.log(this.state.QuickFilters)
      });
    } else {
      const updatedData = updatedFilters.map(obj => ({
        ...obj,
        filterName: filterName
      }));
      const newData = [...this.state.QuickFilters];
      newData.push(...updatedData);
      this.setState({ QuickFilters: newData }, () => {
        //console.log(this.state.QuickFilters)
      });
    }
  };
  handleStateCloseChange = () => {
    this.setState({
      StateQuickFilters: []
    });
  };
  handleCloseChange = () => {
    // this.setState({
    //   QuickFilters: [
    //     {
    //       key: "VERIFIED",
    //       displayName: "VERIFIED",
    //       count: 858,
    //       checked: true
    //     }
    //   ]
    // });
  };
  componentDidMount = async () => {
    const {
      location: { state, isDashBoard }
    } = this.props;
    if (isDashBoard) {
      let projectAwardedBy = state.groupCategory === "STATE" ? true : false;
      this.setState({
        projectAwardedBy: projectAwardedBy
      });
    }

    const userInfo = getLocalstorage("user");
    getGroupRolesForUser(userInfo.groupId)(response => {
      this.setState({
        userGroupInfo: response.payLoadData
      });
    });
    const response = await request(
      getProjectList(transformProjectListPayload(this.state.static_payload))
    );
    this.setState({ staticfilterdata: response.data.data.filters });
    const state_response = await request(
      getProjectList(
        transformProjectListPayload(this.state.static_payload_for_state)
      )
    );
    this.setState({
      state_static_filter_data: state_response.data.data.filters
    });
    // console.log(this.state.state_static_filter_data);
  };
  componentDidUpdate(prevProps, prevState) {
    const {
      isLoading,
      data: projectListDTO,
      selectedFilters,
      bubbleFilters
    } = this.props.projectListReducer;

    const hasReducerValuesChanged =
      prevState.isLoading !== isLoading ||
      prevState.projectListDTO !== projectListDTO;

    if (!hasReducerValuesChanged) return;

    let newFiltersData = [...prevState.QuickFilters];
    let newFiltersStateData = [...prevState.StateQuickFilters];

    bubbleFilters.forEach(item => {
      for (const [filterName, filters] of Object.entries(item)) {
        filters.forEach(filter => {
          if (!newFiltersData.some(f => f.key === filter.key)) {
            newFiltersData.push({
              key: filter.key,
              displayName: filter.displayName,
              checked: true,
              filterName
            });
          }

          if (!newFiltersStateData.some(f => f.key === filter.key)) {
            newFiltersStateData.push({
              key: filter.key,
              displayName: filter.displayName,
              checked: true,
              filterName
            });
          }
        });
      }
    });

    this.setState({
      isLoading,
      projectListDTO,
      selectedFilters,
      QuickFilters: newFiltersData.filter(f => f.key && f.displayName),
      StateQuickFilters: newFiltersStateData.filter(f => f.key && f.displayName)
    });
  }

  clearAll = () => {
    const { CLEAR_ISSUE_OLD_FILTERS_ACTION } = this.props;
    this.setState(
      {
        dates: {},
        search: "",
        temporaryFilters: { offset: 0, limit: 10 },
        ProjectStagecurrent: [],
        QuickFilters: [],
        StateQuickFilters: []
      },

      () => CLEAR_ISSUE_OLD_FILTERS_ACTION(this.getGroupCategory()),
      localStorage.setItem("ClearAll", JSON.stringify(true))
    );
  };

  filterOpen = () => {
    var x = document.getElementsByClassName("common-list-responsive-filters");
    var y = document.getElementsByClassName("close-filter");
    if (
      x[0].classList.contains("display-none") &&
      y[0].style.display === "none"
    ) {
      x[0].classList.add("display-block");
      x[0].classList.remove("display-none");
      y[0].style.display = "block";
    } else if (x[0].classList.contains("display-block")) {
      x[0].classList.add("display-none");
      x[0].classList.remove("display-block");
    } else {
      x[0].classList.add("display-block");
      y[0].style.display = "block";
    }
  };
  filterClose = () => {
    var x = document.getElementsByClassName("common-list-responsive-filters");
    var y = document.getElementsByClassName("close-filter");
    if (
      x[0].classList.contains("display-block") &&
      y[0].style.display === "block"
    ) {
      x[0].classList.add("display-none");
      x[0].classList.remove("display-block");
      y[0].style.display = "none";
    }
    setLocalstorage("tabIndexSelected", 0);
  };

  onPageChange = data => {
    const {
      GET_PROJECT_LIST_ACTION,
      projectListReducer: { selectedFilters }
    } = this.props;
    let offset = Math.ceil(data.selected);
    GET_PROJECT_LIST_ACTION({
      ...selectedFilters,
      offset,
      ...{ groupCategory: this.getGroupCategory() }
    });
    scrollToPosition({ top: 0 });
  };
  handleCheckbox1 = (filter, filterName) => {
    //console.log(filter);
    //console.log(filterName);
    //console.log(this.state.QuickFilters);
    this.setState(
      {
        QuickFilters: this.state.QuickFilters.filter(function(val) {
          return val !== filter;
        })
      },
      () => {
        const filteredDisplayNames1 = this.state.QuickFilters.filter(
          item => item.filterName === "projectFlags"
        ).map(item => item);
        this.setState({ Monitoringflagcurrent: filteredDisplayNames1 });
        const filteredDisplayNames2 = this.state.QuickFilters.filter(
          item => item.filterName === "projectTags"
        ).map(item => item);
        this.setState({ ProjectStatuscurrent: filteredDisplayNames2 });
        const filteredDisplayNames3 = this.state.QuickFilters.filter(
          item => item.filterName === "projectStage"
        ).map(item => item);
        this.setState({ ProjectStagecurrent: filteredDisplayNames3 });
        const filteredDisplayNames4 = this.state.QuickFilters.filter(
          item => item.filterName === "sponsoringMinistry"
        ).map(item => item);
        this.setState({
          ProjectSponsoringMinistrycurrent: filteredDisplayNames4
        });
        const filteredDisplayNames5 = this.state.QuickFilters.filter(
          item => item.filterName === "projectLocation"
        ).map(item => item);
        this.setState({ ProjectLocationcurrent: filteredDisplayNames5 });
        const filteredDisplayNames6 = this.state.QuickFilters.filter(
          item => item.filterName === "projectLocation"
        ).map(item => item);
        this.setState({ ProjectLocationcurrent: filteredDisplayNames6 });
        const filteredDisplayNames7 = this.state.QuickFilters.filter(
          item => item.filterName === "projectImplementationMode"
        ).map(item => item);
        this.setState({ ImplementationModecurrent: filteredDisplayNames7 });
        const filteredDisplayNames8 = this.state.QuickFilters.filter(
          item => item.filterName === "projectZones"
        ).map(item => item);
        //console.log(filteredDisplayNames8);
        this.setState({ ProjectZonecurrent: filteredDisplayNames8 });
        if (filterName == "projectFlags") {
          const entries = Object.entries(filter);
          const lastEntry = entries.pop();
          delete filter[lastEntry[0]];
          filter.checked = false;
          this.postFilterData1(filter, filterName);
        } else if (filterName == "projectTags") {
          const entries = Object.entries(filter);
          const lastEntry = entries.pop();
          delete filter[lastEntry[0]];
          filter.checked = false;
          this.postFilterData2(filter, filterName);
        } else if (filterName == "projectStage") {
          const entries = Object.entries(filter);
          const lastEntry = entries.pop();
          delete filter[lastEntry[0]];
          filter.checked = false;
          this.postFilterData3(filter, filterName);
        } else if (filterName == "sponsoringMinistry") {
          const entries = Object.entries(filter);
          const lastEntry = entries.pop();
          delete filter[lastEntry[0]];
          filter.checked = false;
          this.postFilterData4(filter, filterName);
        } else if (filterName == "projectLocation") {
          const entries = Object.entries(filter);
          const lastEntry = entries.pop();
          delete filter[lastEntry[0]];
          filter.checked = false;
          this.postFilterData5(filter, filterName);
        } else if (filterName == "projectImplementationMode") {
          const entries = Object.entries(filter);
          const lastEntry = entries.pop();
          delete filter[lastEntry[0]];
          filter.checked = false;
          this.postFilterData6(filter, filterName);
        } else if (filterName == "projectZones") {
          const entries = Object.entries(filter);
          const lastEntry = entries.pop();
          delete filter[lastEntry[0]];
          filter.checked = false;
          this.postFilterData7(filter, filterName);
        } else {
          const entries = Object.entries(filter);
          const lastEntry = entries.pop();
          delete filter[lastEntry[0]];
          filter.checked = false;
          this.postFilterData(filter, filterName);
        }
      }
    );
  };

  handleStateCheckbox = (filter, filterName) => {
    this.setState(
      {
        StateQuickFilters: this.state.StateQuickFilters.filter(function(val) {
          return val !== filter;
        })
      },
      () => {
        const filteredDisplayNames1 = this.state.StateQuickFilters.filter(
          item => item.filterName === "projectFlags"
        ).map(item => item);
        this.setState({ Monitoringflag_State: filteredDisplayNames1 });
        const filteredDisplayNames2 = this.state.StateQuickFilters.filter(
          item => item.filterName === "projectTags"
        ).map(item => item);
        this.setState({ ProjectStatus_State: filteredDisplayNames2 });
        const filteredDisplayNames3 = this.state.StateQuickFilters.filter(
          item => item.filterName === "projectStage"
        ).map(item => item);
        this.setState({ ProjectStage_State: filteredDisplayNames3 });
        const filteredDisplayNames4 = this.state.StateQuickFilters.filter(
          item => item.filterName === "sponsoringMinistry"
        ).map(item => item);
        this.setState({
          ProjectSponsoringDepartment_State: filteredDisplayNames4
        });
        const filteredDisplayNames5 = this.state.StateQuickFilters.filter(
          item => item.filterName === "districtProjectLocation"
        ).map(item => item);
        this.setState({ ProjectDistrict_State: filteredDisplayNames5 });
        const filteredDisplayNames7 = this.state.StateQuickFilters.filter(
          item => item.filterName === "projectImplementationMode"
        ).map(item => item);
        this.setState({ ImplementationMode_State: filteredDisplayNames7 });
        const filteredDisplayNames8 = this.state.StateQuickFilters.filter(
          item => item.filterName === "projectCost"
        ).map(item => item);
        //console.log(filteredDisplayNames8);
        this.setState({ ProjectCost_State: filteredDisplayNames8 });
        if (filterName == "projectFlags") {
          const entries = Object.entries(filter);
          const lastEntry = entries.pop();
          delete filter[lastEntry[0]];
          filter.checked = false;
          this.postFilterData_State1(filter, filterName);
        } else if (filterName == "projectTags") {
          const entries = Object.entries(filter);
          const lastEntry = entries.pop();
          delete filter[lastEntry[0]];
          filter.checked = false;
          this.postFilterData_State2(filter, filterName);
        } else if (filterName == "projectStage") {
          const entries = Object.entries(filter);
          const lastEntry = entries.pop();
          delete filter[lastEntry[0]];
          filter.checked = false;
          this.postFilterData_State3(filter, filterName);
        } else if (filterName == "sponsoringMinistry") {
          const entries = Object.entries(filter);
          const lastEntry = entries.pop();
          delete filter[lastEntry[0]];
          filter.checked = false;
          this.postFilterData_State4(filter, filterName);
        } else if (filterName == "districtProjectLocation") {
          const entries = Object.entries(filter);
          const lastEntry = entries.pop();
          delete filter[lastEntry[0]];
          filter.checked = false;
          this.postFilterData_State5(filter, filterName);
        } else if (filterName == "projectImplementationMode") {
          const entries = Object.entries(filter);
          const lastEntry = entries.pop();
          delete filter[lastEntry[0]];
          filter.checked = false;
          this.postFilterData_State6(filter, filterName);
        } else if (filterName == "projectCost") {
          const entries = Object.entries(filter);
          const lastEntry = entries.pop();
          delete filter[lastEntry[0]];
          filter.checked = false;
          this.postFilterData_State7(filter, filterName);
        } else {
          const entries = Object.entries(filter);
          const lastEntry = entries.pop();
          delete filter[lastEntry[0]];
          filter.checked = false;
          this.postFilterData(filter, filterName);
        }
      }
    );
  };
  postFilterData = (
    value,
    filterName,
    isResponsive = false,
    isApplied = false
  ) => {
    const {
      props: {
        GET_PROJECT_LIST_ACTION,
        projectListReducer: { selectedFilters }
      },

      state: { temporaryFilters }
    } = this;

    let val = null;
    let currentFilter = isResponsive
      ? selectedFilters[filterName] || temporaryFilters[filterName]
      : selectedFilters[filterName];

    let extraParams = {};
    console.log(this.state.projectAwardedBy);

    if (value.checked) {
      const newValue1 = { ...value, filterName: filterName };
      const newItems1 = [...this.state.QuickFilters];
      const newItems2 = [...this.state.StateQuickFilters];
      newItems1.push(newValue1);
      newItems2.push(newValue1);
      this.setState(
        { QuickFilters: newItems1, StateQuickFilters: newItems2 },
        () => {
          console.log(this.state.StateQuickFilters);
        }
      );
    } else {
      const targetObjectIndex = this.state.QuickFilters.findIndex(
        item => item.displayName === value.displayName
      );

      if (targetObjectIndex !== -1) {
        this.state.QuickFilters.splice(targetObjectIndex, 1);
      }

      const targetObjectIndex1 = this.state.StateQuickFilters.findIndex(
        item => item.displayName === value.displayName
      );

      if (targetObjectIndex1 !== -1) {
        this.state.StateQuickFilters.splice(targetObjectIndex1, 1);
      }
    }
    switch (filterName) {
      // in this case value is object
      case "sponsoringMinistry":
      case "sponsoringDepartment":
      case "projectScheme":
      case "sponsoringState":
      case "districtStateDept":
      case "recipientMinistry":
      case "projectStage":
      case "projectSector":
      case "projectTags":
      case "projectFlags":
      case "projectImplementationMode":
      case "recipientDistDept":
      case "projectProponent":
      case "bucket":
      case "milestone":
      case "bucketStatus":
      case "milestoneStatus":
      case "projectZones":
      case "districtProjectLocation":
      case "projectLocation":
        currentFilter = currentFilter || [];
        val = currentFilter.find(val => val.key === value.key);
        if (Array.isArray(value)) {
          if (value.length == 0) {
            currentFilter = value;
            //console.log(selectedFilters);
          } else {
            value.map(item => {
              !val
                ? currentFilter.push(item)
                : (currentFilter = currentFilter.filter(
                    val => val.key !== item.key
                  ));
            });
            var set = new Set();
            var results = [];
            //currentFilter=value
            for (let list of currentFilter) {
              let id = Object.values(list).join("");
              if (!set.has(id)) {
                set.add(id);
                results.push(list);
              }
            }
            currentFilter = results;
            currentFilter = value;
          }
        } else {
          !val
            ? currentFilter.push(value)
            : (currentFilter = currentFilter.filter(
                val => val.key !== value.key
              ));
        }

        break;

      case "projectCost":
      case "delayedProject":
      case "costOverRun":
        currentFilter = currentFilter || [];
        const { key } = value || {};
        const from = key.split("-")[0];
        const to = key.split("-")[1];

        if (isValidArray(currentFilter)) {
          const index = currentFilter.findIndex(value => {
            const { key } = value;
            return key.split("-")[0] === from && key.split("-")[1] === to;
          });

          index < 0
            ? currentFilter.push({ ...value, key: from + "-" + to })
            : currentFilter.splice(index, 1);
        } else {
          currentFilter.push({ ...value, key: from + "-" + to });
        }
        break;

      // In this case value is boolean
      case "pmg":
      case "pragatiReview":
        currentFilter = value.checked;
        break;

      case "search":
      case "createdDate":
        currentFilter = value;
        extraParams = { sortBy: null, sortOrder: null };
        break;

      default:
        break;
    }
    let filters = {
      ...selectedFilters,
      [filterName]: currentFilter,
      ...extraParams
    };
    let filterArr = [
      "sponsoringMinistry",
      "sponsoringDepartment",
      "sponsoringState",
      "districtStateDept",
      "projectStage",
      "projectCost",
      "stateProjectCost",
      "recipientMinistry",
      "recipientDistDept",
      "projectTags",
      "projectFlags",
      "projectSector",
      "projectImplementationMode",
      "projectProponent",
      "projectLocation",
      "projectZones",
      "districtProjectLocation"
    ];

    let test =
      Object.keys(filters) &&
      Object.keys(filters).length &&
      Object.keys(filters).some(function(e) {
        if (filterArr.includes(e)) {
          if (Array.isArray(filters[e])) {
            return filters[e].length;
          } else {
            return true;
          }
        }
      });
    if (!test) setLocalstorage("isSortClicked", false);
    GET_PROJECT_LIST_ACTION({
      ...selectedFilters,
      [filterName]: currentFilter,
      offset: 0,
      limit: 10,
      ...extraParams,
      ...{ groupCategory: this.getGroupCategory() }
    });
  };
  postFilterData_State1 = (
    value,
    filterName,
    isResponsive = false,
    isApplied = false
  ) => {
    const {
      props: {
        GET_PROJECT_LIST_ACTION,
        projectListReducer: { selectedFilters }
      },

      state: { temporaryFilters }
    } = this;
    let val = null;
    let currentFilter = isResponsive
      ? selectedFilters[filterName] || temporaryFilters[filterName]
      : selectedFilters[filterName];

    let extraParams = {};
    switch (filterName) {
      // in this case value is object
      case "sponsoringMinistry":
      case "sponsoringDepartment":
      case "projectScheme":
      case "sponsoringState":
      case "districtStateDept":
      case "recipientMinistry":
      case "projectStage":
      case "projectSector":
      case "projectTags":
      case "projectFlags":
      case "projectImplementationMode":
      case "recipientDistDept":
      case "projectProponent":
      case "bucket":
      case "milestone":
      case "bucketStatus":
      case "milestoneStatus":
      case "projectLocation":
      case "projectZones":
      case "districtProjectLocation":
      case "projectCost":
        currentFilter = currentFilter || [];
        val = currentFilter.find(val => val.key === value.key);
        if (Array.isArray(value)) {
          if (value.length == 0) {
            currentFilter = value;
          } else {
            value.map(item => {
              !val
                ? currentFilter.push(item)
                : (currentFilter = currentFilter.filter(
                    val => val.key !== item.key
                  ));
            });
            var set = new Set();
            var results = [];
            //currentFilter=value
            for (let list of currentFilter) {
              let id = Object.values(list).join("");
              if (!set.has(id)) {
                set.add(id);
                results.push(list);
              }
            }
            currentFilter = results;
            currentFilter = value;
          }
        } else {
          !val
            ? currentFilter.push(value)
            : (currentFilter = currentFilter.filter(
                val => val.key !== value.key
              ));
        }

        break;
      case "delayedProject":
      case "costOverRun":
        currentFilter = currentFilter || [];
        const { key } = value || {};
        const from = key.split("-")[0];
        const to = key.split("-")[1];

        if (isValidArray(currentFilter)) {
          const index = currentFilter.findIndex(value => {
            const { key } = value;
            return key.split("-")[0] === from && key.split("-")[1] === to;
          });

          index < 0
            ? currentFilter.push({ ...value, key: from + "-" + to })
            : currentFilter.splice(index, 1);
        } else {
          currentFilter.push({ ...value, key: from + "-" + to });
        }
        break;

      // In this case value is boolean
      case "pmg":
      case "pragatiReview":
        currentFilter = value.checked;
        break;

      case "search":
      case "createdDate":
        currentFilter = value;
        extraParams = { sortBy: null, sortOrder: null };
        break;

      default:
        break;
    }

    let filters = {
      ...selectedFilters,
      [filterName]: currentFilter,
      ...extraParams
    };
    let filterArr = [
      "sponsoringMinistry",
      "sponsoringDepartment",
      "sponsoringState",
      "districtStateDept",
      "projectStage",
      "projectCost",
      "stateProjectCost",
      "recipientMinistry",
      "recipientDistDept",
      "projectTags",
      "projectFlags",
      "projectSector",
      "projectImplementationMode",
      "projectProponent",
      "projectLocation",
      "projectZones",
      "districtProjectLocation"
    ];

    let test =
      Object.keys(filters) &&
      Object.keys(filters).length &&
      Object.keys(filters).some(function(e) {
        if (filterArr.includes(e)) {
          if (Array.isArray(filters[e])) {
            return filters[e].length;
          } else {
            return true;
          }
        }
      });

    if (!test) setLocalstorage("isSortClicked", false);
    if (selectedFilters.hasOwnProperty("projectStage")) {
      this.setState({ ProjectStagecurrent: selectedFilters.projectStage });
    }
    this.setState({ Monitoringflag_State: currentFilter }, () => {
      GET_PROJECT_LIST_ACTION({
        ...selectedFilters,
        [this.state.quickfilterdata_state[0]]: this.state.Monitoringflag_State,
        [this.state.quickfilterdata_state[1]]: this.state.ProjectStatus_State,
        [this.state.quickfilterdata_state[2]]: this.state.ProjectStage_State,
        [this.state.quickfilterdata_state[3]]: this.state
          .ProjectSponsoringDepartment_State,
        [this.state.quickfilterdata_state[4]]: this.state.ProjectDistrict_State,
        [this.state.quickfilterdata_state[5]]: this.state
          .ImplementationMode_State,
        [this.state.quickfilterdata_state[6]]: this.state.ProjectCost_State,
        offset: 0,
        limit: 10,
        ...extraParams,
        ...{ groupCategory: this.getGroupCategory() }
      });
    });
  };

  postFilterData_State2 = (
    value,
    filterName,
    isResponsive = false,
    isApplied = false
  ) => {
    const {
      props: {
        GET_PROJECT_LIST_ACTION,
        projectListReducer: { selectedFilters }
      },

      state: { temporaryFilters }
    } = this;
    let val = null;
    let currentFilter = isResponsive
      ? selectedFilters[filterName] || temporaryFilters[filterName]
      : selectedFilters[filterName];

    let extraParams = {};
    switch (filterName) {
      // in this case value is object
      case "sponsoringMinistry":
      case "sponsoringDepartment":
      case "projectScheme":
      case "sponsoringState":
      case "districtStateDept":
      case "recipientMinistry":
      case "projectStage":
      case "projectSector":
      case "projectTags":
      case "projectFlags":
      case "projectImplementationMode":
      case "recipientDistDept":
      case "projectProponent":
      case "bucket":
      case "milestone":
      case "bucketStatus":
      case "milestoneStatus":
      case "projectLocation":
      case "projectZones":
      case "districtProjectLocation":
      case "projectCost":
        currentFilter = currentFilter || [];
        val = currentFilter.find(val => val.key === value.key);
        if (Array.isArray(value)) {
          if (value.length == 0) {
            currentFilter = value;
          } else {
            value.map(item => {
              !val
                ? currentFilter.push(item)
                : (currentFilter = currentFilter.filter(
                    val => val.key !== item.key
                  ));
            });
            var set = new Set();
            var results = [];
            //currentFilter=value
            for (let list of currentFilter) {
              let id = Object.values(list).join("");
              if (!set.has(id)) {
                set.add(id);
                results.push(list);
              }
            }
            currentFilter = results;
            currentFilter = value;
          }
        } else {
          !val
            ? currentFilter.push(value)
            : (currentFilter = currentFilter.filter(
                val => val.key !== value.key
              ));
        }

        break;
      case "delayedProject":
      case "costOverRun":
        currentFilter = currentFilter || [];
        const { key } = value || {};
        const from = key.split("-")[0];
        const to = key.split("-")[1];

        if (isValidArray(currentFilter)) {
          const index = currentFilter.findIndex(value => {
            const { key } = value;
            return key.split("-")[0] === from && key.split("-")[1] === to;
          });

          index < 0
            ? currentFilter.push({ ...value, key: from + "-" + to })
            : currentFilter.splice(index, 1);
        } else {
          currentFilter.push({ ...value, key: from + "-" + to });
        }
        break;

      // In this case value is boolean
      case "pmg":
      case "pragatiReview":
        currentFilter = value.checked;
        break;

      case "search":
      case "createdDate":
        currentFilter = value;
        extraParams = { sortBy: null, sortOrder: null };
        break;

      default:
        break;
    }

    let filters = {
      ...selectedFilters,
      [filterName]: currentFilter,
      ...extraParams
    };
    let filterArr = [
      "sponsoringMinistry",
      "sponsoringDepartment",
      "sponsoringState",
      "districtStateDept",
      "projectStage",
      "projectCost",
      "stateProjectCost",
      "recipientMinistry",
      "recipientDistDept",
      "projectTags",
      "projectFlags",
      "projectSector",
      "projectImplementationMode",
      "projectProponent",
      "projectLocation",
      "projectZones",
      "districtProjectLocation"
    ];

    let test =
      Object.keys(filters) &&
      Object.keys(filters).length &&
      Object.keys(filters).some(function(e) {
        if (filterArr.includes(e)) {
          if (Array.isArray(filters[e])) {
            return filters[e].length;
          } else {
            return true;
          }
        }
      });

    if (!test) setLocalstorage("isSortClicked", false);
    if (selectedFilters.hasOwnProperty("projectStage")) {
      this.setState({ ProjectStage_State: selectedFilters.projectStage });
    }
    this.setState({ ProjectStatus_State: currentFilter }, () => {
      GET_PROJECT_LIST_ACTION({
        ...selectedFilters,
        [this.state.quickfilterdata_state[0]]: this.state.Monitoringflag_State,
        [this.state.quickfilterdata_state[1]]: this.state.ProjectStatus_State,
        [this.state.quickfilterdata_state[2]]: this.state.ProjectStage_State,
        [this.state.quickfilterdata_state[3]]: this.state
          .ProjectSponsoringDepartment_State,
        [this.state.quickfilterdata_state[4]]: this.state.ProjectDistrict_State,
        [this.state.quickfilterdata_state[5]]: this.state
          .ImplementationMode_State,
        [this.state.quickfilterdata_state[6]]: this.state.ProjectCost_State,
        offset: 0,
        limit: 10,
        ...extraParams,
        ...{ groupCategory: this.getGroupCategory() }
      });
    });
  };
  postFilterData_State3 = (
    value,
    filterName,
    isResponsive = false,
    isApplied = false
  ) => {
    const {
      props: {
        GET_PROJECT_LIST_ACTION,
        projectListReducer: { selectedFilters }
      },

      state: { temporaryFilters }
    } = this;
    let val = null;
    let currentFilter = isResponsive
      ? selectedFilters[filterName] || temporaryFilters[filterName]
      : selectedFilters[filterName];

    let extraParams = {};
    switch (filterName) {
      // in this case value is object
      case "sponsoringMinistry":
      case "sponsoringDepartment":
      case "projectScheme":
      case "sponsoringState":
      case "districtStateDept":
      case "recipientMinistry":
      case "projectStage":
      case "projectSector":
      case "projectTags":
      case "projectFlags":
      case "projectImplementationMode":
      case "recipientDistDept":
      case "projectProponent":
      case "bucket":
      case "milestone":
      case "bucketStatus":
      case "milestoneStatus":
      case "projectLocation":
      case "projectZones":
      case "districtProjectLocation":
      case "projectCost":
        currentFilter = currentFilter || [];
        val = currentFilter.find(val => val.key === value.key);
        if (Array.isArray(value)) {
          if (value.length == 0) {
            currentFilter = value;
          } else {
            value.map(item => {
              !val
                ? currentFilter.push(item)
                : (currentFilter = currentFilter.filter(
                    val => val.key !== item.key
                  ));
            });
            var set = new Set();
            var results = [];
            //currentFilter=value
            for (let list of currentFilter) {
              let id = Object.values(list).join("");
              if (!set.has(id)) {
                set.add(id);
                results.push(list);
              }
            }
            currentFilter = results;
            currentFilter = value;
          }
        } else {
          !val
            ? currentFilter.push(value)
            : (currentFilter = currentFilter.filter(
                val => val.key !== value.key
              ));
        }

        break;

      case "projectCost":
      case "delayedProject":
      case "costOverRun":
        currentFilter = currentFilter || [];
        const { key } = value || {};
        const from = key.split("-")[0];
        const to = key.split("-")[1];

        if (isValidArray(currentFilter)) {
          const index = currentFilter.findIndex(value => {
            const { key } = value;
            return key.split("-")[0] === from && key.split("-")[1] === to;
          });

          index < 0
            ? currentFilter.push({ ...value, key: from + "-" + to })
            : currentFilter.splice(index, 1);
        } else {
          currentFilter.push({ ...value, key: from + "-" + to });
        }
        break;

      // In this case value is boolean
      case "pmg":
      case "pragatiReview":
        currentFilter = value.checked;
        break;

      case "search":
      case "createdDate":
        currentFilter = value;
        extraParams = { sortBy: null, sortOrder: null };
        break;

      default:
        break;
    }

    let filters = {
      ...selectedFilters,
      [filterName]: currentFilter,
      ...extraParams
    };
    let filterArr = [
      "sponsoringMinistry",
      "sponsoringDepartment",
      "sponsoringState",
      "districtStateDept",
      "projectStage",
      "projectCost",
      "stateProjectCost",
      "recipientMinistry",
      "recipientDistDept",
      "projectTags",
      "projectFlags",
      "projectSector",
      "projectImplementationMode",
      "projectProponent",
      "projectLocation",
      "projectZones",
      "districtProjectLocation"
    ];

    let test =
      Object.keys(filters) &&
      Object.keys(filters).length &&
      Object.keys(filters).some(function(e) {
        if (filterArr.includes(e)) {
          if (Array.isArray(filters[e])) {
            return filters[e].length;
          } else {
            return true;
          }
        }
      });

    if (!test) setLocalstorage("isSortClicked", false);
    if (selectedFilters.hasOwnProperty("projectStage")) {
      this.setState({ ProjectStage_State: selectedFilters.projectStage });
    }
    this.setState({ ProjectStage_State: currentFilter }, () => {
      GET_PROJECT_LIST_ACTION({
        ...selectedFilters,
        [this.state.quickfilterdata_state[0]]: this.state.Monitoringflag_State,
        [this.state.quickfilterdata_state[1]]: this.state.ProjectStatus_State,
        [this.state.quickfilterdata_state[2]]: this.state.ProjectStage_State,
        [this.state.quickfilterdata_state[3]]: this.state
          .ProjectSponsoringDepartment_State,
        [this.state.quickfilterdata_state[4]]: this.state.ProjectDistrict_State,
        [this.state.quickfilterdata_state[5]]: this.state
          .ImplementationMode_State,
        [this.state.quickfilterdata_state[6]]: this.state.ProjectCost_State,
        offset: 0,
        limit: 10,
        ...extraParams,
        ...{ groupCategory: this.getGroupCategory() }
      });
    });
  };

  postFilterData_State4 = (
    value,
    filterName,
    isResponsive = false,
    isApplied = false
  ) => {
    const {
      props: {
        GET_PROJECT_LIST_ACTION,
        projectListReducer: { selectedFilters }
      },

      state: { temporaryFilters }
    } = this;
    let val = null;
    let currentFilter = isResponsive
      ? selectedFilters[filterName] || temporaryFilters[filterName]
      : selectedFilters[filterName];

    let extraParams = {};
    switch (filterName) {
      // in this case value is object
      case "sponsoringMinistry":
      case "sponsoringDepartment":
      case "projectScheme":
      case "sponsoringState":
      case "districtStateDept":
      case "recipientMinistry":
      case "projectStage":
      case "projectSector":
      case "projectTags":
      case "projectFlags":
      case "projectImplementationMode":
      case "recipientDistDept":
      case "projectProponent":
      case "bucket":
      case "milestone":
      case "bucketStatus":
      case "milestoneStatus":
      case "projectLocation":
      case "projectZones":
      case "districtProjectLocation":
      case "projectCost":
        currentFilter = currentFilter || [];
        val = currentFilter.find(val => val.key === value.key);
        if (Array.isArray(value)) {
          if (value.length == 0) {
            currentFilter = value;
          } else {
            value.map(item => {
              !val
                ? currentFilter.push(item)
                : (currentFilter = currentFilter.filter(
                    val => val.key !== item.key
                  ));
            });
            var set = new Set();
            var results = [];
            //currentFilter=value
            for (let list of currentFilter) {
              let id = Object.values(list).join("");
              if (!set.has(id)) {
                set.add(id);
                results.push(list);
              }
            }
            currentFilter = results;
            currentFilter = value;
          }
        } else {
          !val
            ? currentFilter.push(value)
            : (currentFilter = currentFilter.filter(
                val => val.key !== value.key
              ));
        }

        break;
      case "delayedProject":
      case "costOverRun":
        currentFilter = currentFilter || [];
        const { key } = value || {};
        const from = key.split("-")[0];
        const to = key.split("-")[1];

        if (isValidArray(currentFilter)) {
          const index = currentFilter.findIndex(value => {
            const { key } = value;
            return key.split("-")[0] === from && key.split("-")[1] === to;
          });

          index < 0
            ? currentFilter.push({ ...value, key: from + "-" + to })
            : currentFilter.splice(index, 1);
        } else {
          currentFilter.push({ ...value, key: from + "-" + to });
        }
        break;

      // In this case value is boolean
      case "pmg":
      case "pragatiReview":
        currentFilter = value.checked;
        break;

      case "search":
      case "createdDate":
        currentFilter = value;
        extraParams = { sortBy: null, sortOrder: null };
        break;

      default:
        break;
    }

    let filters = {
      ...selectedFilters,
      [filterName]: currentFilter,
      ...extraParams
    };
    let filterArr = [
      "sponsoringMinistry",
      "sponsoringDepartment",
      "sponsoringState",
      "districtStateDept",
      "projectStage",
      "projectCost",
      "stateProjectCost",
      "recipientMinistry",
      "recipientDistDept",
      "projectTags",
      "projectFlags",
      "projectSector",
      "projectImplementationMode",
      "projectProponent",
      "projectLocation",
      "projectZones",
      "districtProjectLocation"
    ];

    let test =
      Object.keys(filters) &&
      Object.keys(filters).length &&
      Object.keys(filters).some(function(e) {
        if (filterArr.includes(e)) {
          if (Array.isArray(filters[e])) {
            return filters[e].length;
          } else {
            return true;
          }
        }
      });

    if (!test) setLocalstorage("isSortClicked", false);
    if (selectedFilters.hasOwnProperty("projectStage")) {
      this.setState({ ProjectStage_State: selectedFilters.projectStage });
    }
    this.setState({ ProjectSponsoringDepartment_State: currentFilter }, () => {
      GET_PROJECT_LIST_ACTION({
        ...selectedFilters,
        [this.state.quickfilterdata_state[0]]: this.state.Monitoringflag_State,
        [this.state.quickfilterdata_state[1]]: this.state.ProjectStatus_State,
        [this.state.quickfilterdata_state[2]]: this.state.ProjectStage_State,
        [this.state.quickfilterdata_state[3]]: this.state
          .ProjectSponsoringDepartment_State,
        [this.state.quickfilterdata_state[4]]: this.state.ProjectDistrict_State,
        [this.state.quickfilterdata_state[5]]: this.state
          .ImplementationMode_State,
        [this.state.quickfilterdata_state[6]]: this.state.ProjectCost_State,
        offset: 0,
        limit: 10,
        ...extraParams,
        ...{ groupCategory: this.getGroupCategory() }
      });
    });
  };
  postFilterData_State5 = (
    value,
    filterName,
    isResponsive = false,
    isApplied = false
  ) => {
    const {
      props: {
        GET_PROJECT_LIST_ACTION,
        projectListReducer: { selectedFilters }
      },

      state: { temporaryFilters }
    } = this;
    let val = null;
    let currentFilter = isResponsive
      ? selectedFilters[filterName] || temporaryFilters[filterName]
      : selectedFilters[filterName];

    let extraParams = {};
    switch (filterName) {
      // in this case value is object
      case "sponsoringMinistry":
      case "sponsoringDepartment":
      case "projectScheme":
      case "sponsoringState":
      case "districtStateDept":
      case "recipientMinistry":
      case "projectStage":
      case "projectSector":
      case "projectTags":
      case "projectFlags":
      case "projectImplementationMode":
      case "recipientDistDept":
      case "projectProponent":
      case "bucket":
      case "milestone":
      case "bucketStatus":
      case "milestoneStatus":
      case "projectLocation":
      case "projectZones":
      case "districtProjectLocation":
      case "projectCost":
        currentFilter = currentFilter || [];
        val = currentFilter.find(val => val.key === value.key);
        if (Array.isArray(value)) {
          if (value.length == 0) {
            currentFilter = value;
          } else {
            value.map(item => {
              !val
                ? currentFilter.push(item)
                : (currentFilter = currentFilter.filter(
                    val => val.key !== item.key
                  ));
            });
            var set = new Set();
            var results = [];
            //currentFilter=value
            for (let list of currentFilter) {
              let id = Object.values(list).join("");
              if (!set.has(id)) {
                set.add(id);
                results.push(list);
              }
            }
            currentFilter = results;
            currentFilter = value;
          }
        } else {
          !val
            ? currentFilter.push(value)
            : (currentFilter = currentFilter.filter(
                val => val.key !== value.key
              ));
        }

        break;

      case "delayedProject":
      case "costOverRun":
        currentFilter = currentFilter || [];
        const { key } = value || {};
        const from = key.split("-")[0];
        const to = key.split("-")[1];

        if (isValidArray(currentFilter)) {
          const index = currentFilter.findIndex(value => {
            const { key } = value;
            return key.split("-")[0] === from && key.split("-")[1] === to;
          });

          index < 0
            ? currentFilter.push({ ...value, key: from + "-" + to })
            : currentFilter.splice(index, 1);
        } else {
          currentFilter.push({ ...value, key: from + "-" + to });
        }
        break;

      // In this case value is boolean
      case "pmg":
      case "pragatiReview":
        currentFilter = value.checked;
        break;

      case "search":
      case "createdDate":
        currentFilter = value;
        extraParams = { sortBy: null, sortOrder: null };
        break;

      default:
        break;
    }

    let filters = {
      ...selectedFilters,
      [filterName]: currentFilter,
      ...extraParams
    };
    let filterArr = [
      "sponsoringMinistry",
      "sponsoringDepartment",
      "sponsoringState",
      "districtStateDept",
      "projectStage",
      "projectCost",
      "stateProjectCost",
      "recipientMinistry",
      "recipientDistDept",
      "projectTags",
      "projectFlags",
      "projectSector",
      "projectImplementationMode",
      "projectProponent",
      "projectLocation",
      "projectZones",
      "districtProjectLocation"
    ];

    let test =
      Object.keys(filters) &&
      Object.keys(filters).length &&
      Object.keys(filters).some(function(e) {
        if (filterArr.includes(e)) {
          if (Array.isArray(filters[e])) {
            return filters[e].length;
          } else {
            return true;
          }
        }
      });

    if (!test) setLocalstorage("isSortClicked", false);
    if (selectedFilters.hasOwnProperty("projectStage")) {
      this.setState({ ProjectStage_State: selectedFilters.projectStage });
    }
    this.setState({ ProjectDistrict_State: currentFilter }, () => {
      GET_PROJECT_LIST_ACTION({
        ...selectedFilters,
        [this.state.quickfilterdata_state[0]]: this.state.Monitoringflag_State,
        [this.state.quickfilterdata_state[1]]: this.state.ProjectStatus_State,
        [this.state.quickfilterdata_state[2]]: this.state.ProjectStage_State,
        [this.state.quickfilterdata_state[3]]: this.state
          .ProjectSponsoringDepartment_State,
        [this.state.quickfilterdata_state[4]]: this.state.ProjectDistrict_State,
        [this.state.quickfilterdata_state[5]]: this.state
          .ImplementationMode_State,
        [this.state.quickfilterdata_state[6]]: this.state.ProjectCost_State,
        offset: 0,
        limit: 10,
        ...extraParams,
        ...{ groupCategory: this.getGroupCategory() }
      });
    });
  };

  postFilterData_State6 = (
    value,
    filterName,
    isResponsive = false,
    isApplied = false
  ) => {
    const {
      props: {
        GET_PROJECT_LIST_ACTION,
        projectListReducer: { selectedFilters }
      },

      state: { temporaryFilters }
    } = this;
    let val = null;
    let currentFilter = isResponsive
      ? selectedFilters[filterName] || temporaryFilters[filterName]
      : selectedFilters[filterName];

    let extraParams = {};
    switch (filterName) {
      // in this case value is object
      case "sponsoringMinistry":
      case "sponsoringDepartment":
      case "projectScheme":
      case "sponsoringState":
      case "districtStateDept":
      case "recipientMinistry":
      case "projectStage":
      case "projectSector":
      case "projectTags":
      case "projectFlags":
      case "projectImplementationMode":
      case "recipientDistDept":
      case "projectProponent":
      case "bucket":
      case "milestone":
      case "bucketStatus":
      case "milestoneStatus":
      case "projectLocation":
      case "projectZones":
      case "districtProjectLocation":
      case "projectCost":
        currentFilter = currentFilter || [];
        val = currentFilter.find(val => val.key === value.key);
        if (Array.isArray(value)) {
          if (value.length == 0) {
            currentFilter = value;
          } else {
            value.map(item => {
              !val
                ? currentFilter.push(item)
                : (currentFilter = currentFilter.filter(
                    val => val.key !== item.key
                  ));
            });
            var set = new Set();
            var results = [];
            //currentFilter=value
            for (let list of currentFilter) {
              let id = Object.values(list).join("");
              if (!set.has(id)) {
                set.add(id);
                results.push(list);
              }
            }
            currentFilter = results;
            currentFilter = value;
          }
        } else {
          !val
            ? currentFilter.push(value)
            : (currentFilter = currentFilter.filter(
                val => val.key !== value.key
              ));
        }

        break;

      case "delayedProject":
      case "costOverRun":
        currentFilter = currentFilter || [];
        const { key } = value || {};
        const from = key.split("-")[0];
        const to = key.split("-")[1];

        if (isValidArray(currentFilter)) {
          const index = currentFilter.findIndex(value => {
            const { key } = value;
            return key.split("-")[0] === from && key.split("-")[1] === to;
          });

          index < 0
            ? currentFilter.push({ ...value, key: from + "-" + to })
            : currentFilter.splice(index, 1);
        } else {
          currentFilter.push({ ...value, key: from + "-" + to });
        }
        break;

      // In this case value is boolean
      case "pmg":
      case "pragatiReview":
        currentFilter = value.checked;
        break;

      case "search":
      case "createdDate":
        currentFilter = value;
        extraParams = { sortBy: null, sortOrder: null };
        break;

      default:
        break;
    }

    let filters = {
      ...selectedFilters,
      [filterName]: currentFilter,
      ...extraParams
    };
    let filterArr = [
      "sponsoringMinistry",
      "sponsoringDepartment",
      "sponsoringState",
      "districtStateDept",
      "projectStage",
      "projectCost",
      "stateProjectCost",
      "recipientMinistry",
      "recipientDistDept",
      "projectTags",
      "projectFlags",
      "projectSector",
      "projectImplementationMode",
      "projectProponent",
      "projectLocation",
      "projectZones",
      "districtProjectLocation"
    ];

    let test =
      Object.keys(filters) &&
      Object.keys(filters).length &&
      Object.keys(filters).some(function(e) {
        if (filterArr.includes(e)) {
          if (Array.isArray(filters[e])) {
            return filters[e].length;
          } else {
            return true;
          }
        }
      });

    if (!test) setLocalstorage("isSortClicked", false);
    if (selectedFilters.hasOwnProperty("projectStage")) {
      this.setState({ ProjectStage_State: selectedFilters.projectStage });
    }
    this.setState({ ImplementationMode_State: currentFilter }, () => {
      GET_PROJECT_LIST_ACTION({
        ...selectedFilters,
        [this.state.quickfilterdata_state[0]]: this.state.Monitoringflag_State,
        [this.state.quickfilterdata_state[1]]: this.state.ProjectStatus_State,
        [this.state.quickfilterdata_state[2]]: this.state.ProjectStage_State,
        [this.state.quickfilterdata_state[3]]: this.state
          .ProjectSponsoringDepartment_State,
        [this.state.quickfilterdata_state[4]]: this.state.ProjectDistrict_State,
        [this.state.quickfilterdata_state[5]]: this.state
          .ImplementationMode_State,
        [this.state.quickfilterdata_state[6]]: this.state.ProjectCost_State,
        offset: 0,
        limit: 10,
        ...extraParams,
        ...{ groupCategory: this.getGroupCategory() }
      });
    });
  };

  postFilterData_State7 = (
    value,
    filterName,
    isResponsive = false,
    isApplied = false
  ) => {
    const {
      props: {
        GET_PROJECT_LIST_ACTION,
        projectListReducer: { selectedFilters }
      },

      state: { temporaryFilters }
    } = this;
    let val = null;
    let currentFilter = isResponsive
      ? selectedFilters[filterName] || temporaryFilters[filterName]
      : selectedFilters[filterName];

    let extraParams = {};
    switch (filterName) {
      // in this case value is object
      case "sponsoringMinistry":
      case "sponsoringDepartment":
      case "projectScheme":
      case "sponsoringState":
      case "districtStateDept":
      case "recipientMinistry":
      case "projectStage":
      case "projectSector":
      case "projectTags":
      case "projectFlags":
      case "projectImplementationMode":
      case "recipientDistDept":
      case "projectProponent":
      case "bucket":
      case "milestone":
      case "bucketStatus":
      case "milestoneStatus":
      case "projectLocation":
      case "projectZones":
      case "districtProjectLocation":
      case "projectCost":
        currentFilter = currentFilter || [];
        val = currentFilter.find(val => val.key === value.key);
        if (Array.isArray(value)) {
          if (value.length == 0) {
            currentFilter = value;
          } else {
            value.map(item => {
              !val
                ? currentFilter.push(item)
                : (currentFilter = currentFilter.filter(
                    val => val.key !== item.key
                  ));
            });
            var set = new Set();
            var results = [];
            //currentFilter=value
            for (let list of currentFilter) {
              let id = Object.values(list).join("");
              if (!set.has(id)) {
                set.add(id);
                results.push(list);
              }
            }
            currentFilter = results;
            currentFilter = value;
          }
        } else {
          !val
            ? currentFilter.push(value)
            : (currentFilter = currentFilter.filter(
                val => val.key !== value.key
              ));
        }

        break;

      // case "projectCost":
      case "delayedProject":
      case "costOverRun":
        currentFilter = currentFilter || [];
        const { key } = value || {};
        const from = key.split("-")[0];
        const to = key.split("-")[1];

        if (isValidArray(currentFilter)) {
          const index = currentFilter.findIndex(value => {
            const { key } = value;
            return key.split("-")[0] === from && key.split("-")[1] === to;
          });

          index < 0
            ? currentFilter.push({ ...value, key: from + "-" + to })
            : currentFilter.splice(index, 1);
        } else {
          currentFilter.push({ ...value, key: from + "-" + to });
        }
        break;

      // In this case value is boolean
      case "pmg":
      case "pragatiReview":
        currentFilter = value.checked;
        break;

      case "search":
      case "createdDate":
        currentFilter = value;
        extraParams = { sortBy: null, sortOrder: null };
        break;

      default:
        break;
    }

    let filters = {
      ...selectedFilters,
      [filterName]: currentFilter,
      ...extraParams
    };
    let filterArr = [
      "sponsoringMinistry",
      "sponsoringDepartment",
      "sponsoringState",
      "districtStateDept",
      "projectStage",
      "projectCost",
      "stateProjectCost",
      "recipientMinistry",
      "recipientDistDept",
      "projectTags",
      "projectFlags",
      "projectSector",
      "projectImplementationMode",
      "projectProponent",
      "projectLocation",
      "projectZones",
      "districtProjectLocation"
    ];

    let test =
      Object.keys(filters) &&
      Object.keys(filters).length &&
      Object.keys(filters).some(function(e) {
        if (filterArr.includes(e)) {
          if (Array.isArray(filters[e])) {
            return filters[e].length;
          } else {
            return true;
          }
        }
      });

    if (!test) setLocalstorage("isSortClicked", false);
    if (selectedFilters.hasOwnProperty("projectStage")) {
      this.setState({ ProjectStage_State: selectedFilters.projectStage });
    }
    this.setState({ ProjectCost_State: currentFilter }, () => {
      GET_PROJECT_LIST_ACTION({
        ...selectedFilters,
        [this.state.quickfilterdata_state[0]]: this.state.Monitoringflag_State,
        [this.state.quickfilterdata_state[1]]: this.state.ProjectStatus_State,
        [this.state.quickfilterdata_state[2]]: this.state.ProjectStage_State,
        [this.state.quickfilterdata_state[3]]: this.state
          .ProjectSponsoringDepartment_State,
        [this.state.quickfilterdata_state[4]]: this.state.ProjectDistrict_State,
        [this.state.quickfilterdata_state[5]]: this.state
          .ImplementationMode_State,
        [this.state.quickfilterdata_state[6]]: this.state.ProjectCost_State,
        offset: 0,
        limit: 10,
        ...extraParams,
        ...{ groupCategory: this.getGroupCategory() }
      });
    });
  };
  postFilterData1 = (
    value,
    filterName,
    isResponsive = false,
    isApplied = false
  ) => {
    const {
      props: {
        GET_PROJECT_LIST_ACTION,
        projectListReducer: { selectedFilters }
      },

      state: { temporaryFilters }
    } = this;
    let val = null;
    let currentFilter = isResponsive
      ? selectedFilters[filterName] || temporaryFilters[filterName]
      : selectedFilters[filterName];

    let extraParams = {};
    switch (filterName) {
      // in this case value is object
      case "sponsoringMinistry":
      case "sponsoringDepartment":
      case "projectScheme":
      case "sponsoringState":
      case "districtStateDept":
      case "recipientMinistry":
      case "projectStage":
      case "projectSector":
      case "projectTags":
      case "projectFlags":
      case "projectImplementationMode":
      case "recipientDistDept":
      case "projectProponent":
      case "bucket":
      case "milestone":
      case "bucketStatus":
      case "milestoneStatus":
      case "projectLocation":
      case "projectZones":
      case "districtProjectLocation":
        currentFilter = currentFilter || [];
        val = currentFilter.find(val => val.key === value.key);
        if (Array.isArray(value)) {
          if (value.length == 0) {
            currentFilter = value;
          } else {
            value.map(item => {
              !val
                ? currentFilter.push(item)
                : (currentFilter = currentFilter.filter(
                    val => val.key !== item.key
                  ));
            });
            var set = new Set();
            var results = [];
            //currentFilter=value
            for (let list of currentFilter) {
              let id = Object.values(list).join("");
              if (!set.has(id)) {
                set.add(id);
                results.push(list);
              }
            }
            currentFilter = results;
            currentFilter = value;
          }
        } else {
          !val
            ? currentFilter.push(value)
            : (currentFilter = currentFilter.filter(
                val => val.key !== value.key
              ));
        }

        break;

      case "projectCost":
      case "delayedProject":
      case "costOverRun":
        currentFilter = currentFilter || [];
        const { key } = value || {};
        const from = key.split("-")[0];
        const to = key.split("-")[1];

        if (isValidArray(currentFilter)) {
          const index = currentFilter.findIndex(value => {
            const { key } = value;
            return key.split("-")[0] === from && key.split("-")[1] === to;
          });

          index < 0
            ? currentFilter.push({ ...value, key: from + "-" + to })
            : currentFilter.splice(index, 1);
        } else {
          currentFilter.push({ ...value, key: from + "-" + to });
        }
        break;

      // In this case value is boolean
      case "pmg":
      case "pragatiReview":
        currentFilter = value.checked;
        break;

      case "search":
      case "createdDate":
        currentFilter = value;
        extraParams = { sortBy: null, sortOrder: null };
        break;

      default:
        break;
    }

    let filters = {
      ...selectedFilters,
      [filterName]: currentFilter,
      ...extraParams
    };
    let filterArr = [
      "sponsoringMinistry",
      "sponsoringDepartment",
      "sponsoringState",
      "districtStateDept",
      "projectStage",
      "projectCost",
      "stateProjectCost",
      "recipientMinistry",
      "recipientDistDept",
      "projectTags",
      "projectFlags",
      "projectSector",
      "projectImplementationMode",
      "projectProponent",
      "projectLocation",
      "projectZones",
      "districtProjectLocation"
    ];

    let test =
      Object.keys(filters) &&
      Object.keys(filters).length &&
      Object.keys(filters).some(function(e) {
        if (filterArr.includes(e)) {
          if (Array.isArray(filters[e])) {
            return filters[e].length;
          } else {
            return true;
          }
        }
      });

    if (!test) setLocalstorage("isSortClicked", false);
    if (selectedFilters.hasOwnProperty("projectStage")) {
      this.setState({ ProjectStagecurrent: selectedFilters.projectStage });
    }
    this.setState({ Monitoringflagcurrent: currentFilter }, () => {
      GET_PROJECT_LIST_ACTION({
        ...selectedFilters,
        [this.state.quickfilterdatanew[0]]: this.state.Monitoringflagcurrent,
        [this.state.quickfilterdatanew[1]]: this.state.ProjectStatuscurrent,
        [this.state.quickfilterdatanew[2]]: this.state.ProjectStagecurrent,
        [this.state.quickfilterdatanew[3]]: this.state
          .ProjectSponsoringMinistrycurrent,
        [this.state.quickfilterdatanew[4]]: this.state.ProjectLocationcurrent,
        [this.state.quickfilterdatanew[5]]: this.state
          .ImplementationModecurrent,
        [this.state.quickfilterdatanew[6]]: this.state.ProjectZonecurrent,
        offset: 0,
        limit: 10,
        ...extraParams,
        ...{ groupCategory: this.getGroupCategory() }
      });
    });

    /*if (isResponsive && !isApplied) {
      let selected = {
        ...selectedFilters,
        [filterName]: currentFilter,
        offset: 0,
        limit: 10,
        ...extraParams,
        ...{ groupCategory: this.getGroupCategory() }
      };

      this.setState({
        temporaryFilters: {
          ...this.state.temporaryFilters,
          ...selected
        }
      });
    } else {
      GET_PROJECT_LIST_ACTION({
        ...selectedFilters,
        [filterName]: currentFilter,
        offset: 0,
        limit: 10,
        ...extraParams,
        ...{ groupCategory: this.getGroupCategory() }
      });
    }*/
  };
  postFilterData2 = (
    value,
    filterName,
    isResponsive = false,
    isApplied = false
  ) => {
    const {
      props: {
        GET_PROJECT_LIST_ACTION,
        projectListReducer: { selectedFilters }
      },

      state: { temporaryFilters }
    } = this;
    let val = null;
    let currentFilter = isResponsive
      ? selectedFilters[filterName] || temporaryFilters[filterName]
      : selectedFilters[filterName];

    let extraParams = {};

    //console.log(filterNamedata)
    switch (filterName) {
      // in this case value is object
      case "sponsoringMinistry":
      case "sponsoringDepartment":
      case "projectScheme":
      case "sponsoringState":
      case "districtStateDept":
      case "recipientMinistry":
      case "projectStage":
      case "projectSector":
      case "projectTags":
      case "projectFlags":
      case "projectImplementationMode":
      case "recipientDistDept":
      case "projectProponent":
      case "bucket":
      case "milestone":
      case "bucketStatus":
      case "milestoneStatus":
      case "projectLocation":
      case "projectZones":
      case "districtProjectLocation":
        currentFilter = currentFilter || [];
        val = currentFilter.find(val => val.key === value.key);
        //console.log(currentFilter)
        //console.log(value)
        if (Array.isArray(value)) {
          if (value.length == 0) {
            currentFilter = value;
          } else {
            value.map(item => {
              !val
                ? currentFilter.push(item)
                : (currentFilter = currentFilter.filter(
                    val => val.key !== item.key
                  ));
            });
            var set = new Set();
            var results = [];
            //currentFilter=value
            for (let list of currentFilter) {
              let id = Object.values(list).join("");
              if (!set.has(id)) {
                set.add(id);
                results.push(list);
              }
            }
            currentFilter = results;
            currentFilter = value;
          }
        } else {
          !val
            ? currentFilter.push(value)
            : (currentFilter = currentFilter.filter(
                val => val.key !== value.key
              ));
        }

        break;

      case "projectCost":
      case "delayedProject":
      case "costOverRun":
        currentFilter = currentFilter || [];
        const { key } = value || {};
        const from = key.split("-")[0];
        const to = key.split("-")[1];

        if (isValidArray(currentFilter)) {
          const index = currentFilter.findIndex(value => {
            const { key } = value;
            return key.split("-")[0] === from && key.split("-")[1] === to;
          });

          index < 0
            ? currentFilter.push({ ...value, key: from + "-" + to })
            : currentFilter.splice(index, 1);
        } else {
          currentFilter.push({ ...value, key: from + "-" + to });
        }
        break;

      // In this case value is boolean
      case "pmg":
      case "pragatiReview":
        currentFilter = value.checked;
        break;

      case "search":
      case "createdDate":
        currentFilter = value;
        extraParams = { sortBy: null, sortOrder: null };
        break;

      default:
        break;
    }

    let filters = {
      ...selectedFilters,
      [filterName]: currentFilter,
      ...extraParams
    };
    let filterArr = [
      "sponsoringMinistry",
      "sponsoringDepartment",
      "sponsoringState",
      "districtStateDept",
      "projectStage",
      "projectCost",
      "stateProjectCost",
      "recipientMinistry",
      "recipientDistDept",
      "projectTags",
      "projectFlags",
      "projectSector",
      "projectImplementationMode",
      "projectProponent",
      "projectLocation",
      "projectZones",
      "districtProjectLocation"
    ];

    let test =
      Object.keys(filters) &&
      Object.keys(filters).length &&
      Object.keys(filters).some(function(e) {
        if (filterArr.includes(e)) {
          if (Array.isArray(filters[e])) {
            return filters[e].length;
          } else {
            return true;
          }
        }
      });

    if (!test) setLocalstorage("isSortClicked", false);
    //const newItems1 = [...this.state.quickfilterdatanew];
    // newItems1.push("projectTags");
    if (selectedFilters.hasOwnProperty("projectStage")) {
      this.setState({ ProjectStagecurrent: selectedFilters.projectStage });
    }
    this.setState({ ProjectStatuscurrent: currentFilter }, () => {
      GET_PROJECT_LIST_ACTION({
        ...selectedFilters,
        [this.state.quickfilterdatanew[0]]: this.state.Monitoringflagcurrent,
        [this.state.quickfilterdatanew[1]]: this.state.ProjectStatuscurrent,
        [this.state.quickfilterdatanew[2]]: this.state.ProjectStagecurrent,
        [this.state.quickfilterdatanew[3]]: this.state
          .ProjectSponsoringMinistrycurrent,
        [this.state.quickfilterdatanew[4]]: this.state.ProjectLocationcurrent,
        [this.state.quickfilterdatanew[5]]: this.state
          .ImplementationModecurrent,
        [this.state.quickfilterdatanew[6]]: this.state.ProjectZonecurrent,
        offset: 0,
        limit: 10,
        ...extraParams,
        ...{ groupCategory: this.getGroupCategory() }
      });
    });
  };
  postFilterData3 = (
    value,
    filterName,
    isResponsive = false,
    isApplied = false
  ) => {
    const {
      props: {
        GET_PROJECT_LIST_ACTION,
        projectListReducer: { selectedFilters }
      },

      state: { temporaryFilters }
    } = this;
    let val = null;
    let currentFilter = isResponsive
      ? selectedFilters[filterName] || temporaryFilters[filterName]
      : selectedFilters[filterName];

    let extraParams = {};

    //console.log(filterNamedata)
    switch (filterName) {
      // in this case value is object
      case "sponsoringMinistry":
      case "sponsoringDepartment":
      case "projectScheme":
      case "sponsoringState":
      case "districtStateDept":
      case "recipientMinistry":
      case "projectStage":
      case "projectSector":
      case "projectTags":
      case "projectFlags":
      case "projectImplementationMode":
      case "recipientDistDept":
      case "projectProponent":
      case "bucket":
      case "milestone":
      case "bucketStatus":
      case "milestoneStatus":
      case "projectLocation":
      case "projectZones":
      case "districtProjectLocation":
        currentFilter = currentFilter || [];
        val = currentFilter.find(val => val.key === value.key);
        //console.log(currentFilter)
        //console.log(value)
        if (Array.isArray(value)) {
          if (value.length == 0) {
            currentFilter = value;
          } else {
            value.map(item => {
              !val
                ? currentFilter.push(item)
                : (currentFilter = currentFilter.filter(
                    val => val.key !== item.key
                  ));
            });
            var set = new Set();
            var results = [];
            //currentFilter=value
            for (let list of currentFilter) {
              let id = Object.values(list).join("");
              if (!set.has(id)) {
                set.add(id);
                results.push(list);
              }
            }
            currentFilter = results;
            currentFilter = value;
          }
        } else {
          !val
            ? currentFilter.push(value)
            : (currentFilter = currentFilter.filter(
                val => val.key !== value.key
              ));
        }

        break;

      case "projectCost":
      case "delayedProject":
      case "costOverRun":
        currentFilter = currentFilter || [];
        const { key } = value || {};
        const from = key.split("-")[0];
        const to = key.split("-")[1];

        if (isValidArray(currentFilter)) {
          const index = currentFilter.findIndex(value => {
            const { key } = value;
            return key.split("-")[0] === from && key.split("-")[1] === to;
          });

          index < 0
            ? currentFilter.push({ ...value, key: from + "-" + to })
            : currentFilter.splice(index, 1);
        } else {
          currentFilter.push({ ...value, key: from + "-" + to });
        }
        break;

      // In this case value is boolean
      case "pmg":
      case "pragatiReview":
        currentFilter = value.checked;
        break;

      case "search":
      case "createdDate":
        currentFilter = value;
        extraParams = { sortBy: null, sortOrder: null };
        break;

      default:
        break;
    }

    let filters = {
      ...selectedFilters,
      [filterName]: currentFilter,
      ...extraParams
    };
    let filterArr = [
      "sponsoringMinistry",
      "sponsoringDepartment",
      "sponsoringState",
      "districtStateDept",
      "projectStage",
      "projectCost",
      "stateProjectCost",
      "recipientMinistry",
      "recipientDistDept",
      "projectTags",
      "projectFlags",
      "projectSector",
      "projectImplementationMode",
      "projectProponent",
      "projectLocation",
      "projectZones",
      "districtProjectLocation"
    ];

    let test =
      Object.keys(filters) &&
      Object.keys(filters).length &&
      Object.keys(filters).some(function(e) {
        if (filterArr.includes(e)) {
          if (Array.isArray(filters[e])) {
            return filters[e].length;
          } else {
            return true;
          }
        }
      });

    if (!test) setLocalstorage("isSortClicked", false);
    //const newItems1 = [...this.state.quickfilterdatanew];
    //newItems1.push("projectStage");
    if (selectedFilters.hasOwnProperty("projectStage")) {
      this.setState({ ProjectStagecurrent: selectedFilters.projectStage });
    }
    this.setState({ ProjectStagecurrent: currentFilter }, () => {
      GET_PROJECT_LIST_ACTION({
        ...selectedFilters,
        [this.state.quickfilterdatanew[0]]: this.state.Monitoringflagcurrent,
        [this.state.quickfilterdatanew[1]]: this.state.ProjectStatuscurrent,
        [this.state.quickfilterdatanew[2]]: this.state.ProjectStagecurrent,
        [this.state.quickfilterdatanew[3]]: this.state
          .ProjectSponsoringMinistrycurrent,
        [this.state.quickfilterdatanew[4]]: this.state.ProjectLocationcurrent,
        [this.state.quickfilterdatanew[5]]: this.state
          .ImplementationModecurrent,
        [this.state.quickfilterdatanew[6]]: this.state.ProjectZonecurrent,
        offset: 0,
        limit: 10,
        ...extraParams,
        ...{ groupCategory: this.getGroupCategory() }
      });
    });
  };
  postFilterData4 = (
    value,
    filterName,
    isResponsive = false,
    isApplied = false
  ) => {
    const {
      props: {
        GET_PROJECT_LIST_ACTION,
        projectListReducer: { selectedFilters }
      },

      state: { temporaryFilters }
    } = this;
    let val = null;
    let currentFilter = isResponsive
      ? selectedFilters[filterName] || temporaryFilters[filterName]
      : selectedFilters[filterName];

    let extraParams = {};

    //console.log(filterNamedata)
    switch (filterName) {
      // in this case value is object
      case "sponsoringMinistry":
      case "sponsoringDepartment":
      case "projectScheme":
      case "sponsoringState":
      case "districtStateDept":
      case "recipientMinistry":
      case "projectStage":
      case "projectSector":
      case "projectTags":
      case "projectFlags":
      case "projectImplementationMode":
      case "recipientDistDept":
      case "projectProponent":
      case "bucket":
      case "milestone":
      case "bucketStatus":
      case "milestoneStatus":
      case "projectLocation":
      case "projectZones":
      case "districtProjectLocation":
        currentFilter = currentFilter || [];
        val = currentFilter.find(val => val.key === value.key);
        //console.log(currentFilter)
        //console.log(value)
        if (Array.isArray(value)) {
          if (value.length == 0) {
            currentFilter = value;
          } else {
            value.map(item => {
              !val
                ? currentFilter.push(item)
                : (currentFilter = currentFilter.filter(
                    val => val.key !== item.key
                  ));
            });
            var set = new Set();
            var results = [];
            //currentFilter=value
            for (let list of currentFilter) {
              let id = Object.values(list).join("");
              if (!set.has(id)) {
                set.add(id);
                results.push(list);
              }
            }
            currentFilter = results;
            currentFilter = value;
          }
        } else {
          !val
            ? currentFilter.push(value)
            : (currentFilter = currentFilter.filter(
                val => val.key !== value.key
              ));
        }

        break;

      case "projectCost":
      case "delayedProject":
      case "costOverRun":
        currentFilter = currentFilter || [];
        const { key } = value || {};
        const from = key.split("-")[0];
        const to = key.split("-")[1];

        if (isValidArray(currentFilter)) {
          const index = currentFilter.findIndex(value => {
            const { key } = value;
            return key.split("-")[0] === from && key.split("-")[1] === to;
          });

          index < 0
            ? currentFilter.push({ ...value, key: from + "-" + to })
            : currentFilter.splice(index, 1);
        } else {
          currentFilter.push({ ...value, key: from + "-" + to });
        }
        break;

      // In this case value is boolean
      case "pmg":
      case "pragatiReview":
        currentFilter = value.checked;
        break;

      case "search":
      case "createdDate":
        currentFilter = value;
        extraParams = { sortBy: null, sortOrder: null };
        break;

      default:
        break;
    }

    let filters = {
      ...selectedFilters,
      [filterName]: currentFilter,
      ...extraParams
    };
    let filterArr = [
      "sponsoringMinistry",
      "sponsoringDepartment",
      "sponsoringState",
      "districtStateDept",
      "projectStage",
      "projectCost",
      "stateProjectCost",
      "recipientMinistry",
      "recipientDistDept",
      "projectTags",
      "projectFlags",
      "projectSector",
      "projectImplementationMode",
      "projectProponent",
      "projectLocation",
      "projectZones",
      "districtProjectLocation"
    ];

    let test =
      Object.keys(filters) &&
      Object.keys(filters).length &&
      Object.keys(filters).some(function(e) {
        if (filterArr.includes(e)) {
          if (Array.isArray(filters[e])) {
            return filters[e].length;
          } else {
            return true;
          }
        }
      });

    if (!test) setLocalstorage("isSortClicked", false);
    //const newItems1 = [...this.state.quickfilterdatanew];
    //newItems1.push("projectStage");
    if (selectedFilters.hasOwnProperty("projectStage")) {
      this.setState({ ProjectStagecurrent: selectedFilters.projectStage });
    }
    this.setState({ ProjectSponsoringMinistrycurrent: currentFilter }, () => {
      GET_PROJECT_LIST_ACTION({
        ...selectedFilters,
        [this.state.quickfilterdatanew[0]]: this.state.Monitoringflagcurrent,
        [this.state.quickfilterdatanew[1]]: this.state.ProjectStatuscurrent,
        [this.state.quickfilterdatanew[2]]: this.state.ProjectStagecurrent,
        [this.state.quickfilterdatanew[3]]: this.state
          .ProjectSponsoringMinistrycurrent,
        [this.state.quickfilterdatanew[4]]: this.state.ProjectLocationcurrent,
        offset: 0,
        limit: 10,
        ...extraParams,
        ...{ groupCategory: this.getGroupCategory() }
      });
    });
  };
  postFilterData5 = (
    value,
    filterName,
    isResponsive = false,
    isApplied = false
  ) => {
    const {
      props: {
        GET_PROJECT_LIST_ACTION,
        projectListReducer: { selectedFilters }
      },

      state: { temporaryFilters }
    } = this;
    let val = null;
    let currentFilter = isResponsive
      ? selectedFilters[filterName] || temporaryFilters[filterName]
      : selectedFilters[filterName];
    let extraParams = {};

    switch (filterName) {
      // in this case value is object
      case "sponsoringMinistry":
      case "sponsoringDepartment":
      case "projectScheme":
      case "sponsoringState":
      case "districtStateDept":
      case "recipientMinistry":
      case "projectStage":
      case "projectSector":
      case "projectTags":
      case "projectFlags":
      case "projectImplementationMode":
      case "recipientDistDept":
      case "projectProponent":
      case "bucket":
      case "milestone":
      case "bucketStatus":
      case "milestoneStatus":
      case "projectLocation":
      case "projectZones":
      case "districtProjectLocation":
        currentFilter = currentFilter || [];
        val = currentFilter.find(val => val.key === value.key);
        //console.log(currentFilter)
        //console.log(value)
        if (Array.isArray(value)) {
          if (value.length == 0) {
            currentFilter = value;
          } else {
            value.map(item => {
              !val
                ? currentFilter.push(item)
                : (currentFilter = currentFilter.filter(
                    val => val.key !== item.key
                  ));
            });
            var set = new Set();
            var results = [];
            //currentFilter=value
            for (let list of currentFilter) {
              let id = Object.values(list).join("");
              if (!set.has(id)) {
                set.add(id);
                results.push(list);
              }
            }
            currentFilter = results;
            currentFilter = value;
          }
        } else {
          !val
            ? currentFilter.push(value)
            : (currentFilter = currentFilter.filter(
                val => val.key !== value.key
              ));
        }

        break;

      case "projectCost":
      case "delayedProject":
      case "costOverRun":
        currentFilter = currentFilter || [];
        const { key } = value || {};
        const from = key.split("-")[0];
        const to = key.split("-")[1];

        if (isValidArray(currentFilter)) {
          const index = currentFilter.findIndex(value => {
            const { key } = value;
            return key.split("-")[0] === from && key.split("-")[1] === to;
          });

          index < 0
            ? currentFilter.push({ ...value, key: from + "-" + to })
            : currentFilter.splice(index, 1);
        } else {
          currentFilter.push({ ...value, key: from + "-" + to });
        }
        break;

      // In this case value is boolean
      case "pmg":
      case "pragatiReview":
        currentFilter = value.checked;
        break;

      case "search":
      case "createdDate":
        currentFilter = value;
        extraParams = { sortBy: null, sortOrder: null };
        break;

      default:
        break;
    }

    let filters = {
      ...selectedFilters,
      [filterName]: currentFilter,
      ...extraParams
    };
    let filterArr = [
      "sponsoringMinistry",
      "sponsoringDepartment",
      "sponsoringState",
      "districtStateDept",
      "projectStage",
      "projectCost",
      "stateProjectCost",
      "recipientMinistry",
      "recipientDistDept",
      "projectTags",
      "projectFlags",
      "projectSector",
      "projectImplementationMode",
      "projectProponent",
      "projectLocation",
      "projectZones",
      "districtProjectLocation"
    ];

    let test =
      Object.keys(filters) &&
      Object.keys(filters).length &&
      Object.keys(filters).some(function(e) {
        if (filterArr.includes(e)) {
          if (Array.isArray(filters[e])) {
            return filters[e].length;
          } else {
            return true;
          }
        }
      });

    if (!test) setLocalstorage("isSortClicked", false);
    if (selectedFilters.hasOwnProperty("projectStage")) {
      this.setState({ ProjectStagecurrent: selectedFilters.projectStage });
    }
    this.setState({ ProjectLocationcurrent: currentFilter }, () => {
      GET_PROJECT_LIST_ACTION({
        ...selectedFilters,
        [this.state.quickfilterdatanew[0]]: this.state.Monitoringflagcurrent,
        [this.state.quickfilterdatanew[1]]: this.state.ProjectStatuscurrent,
        [this.state.quickfilterdatanew[2]]: this.state.ProjectStagecurrent,
        [this.state.quickfilterdatanew[3]]: this.state
          .ProjectSponsoringMinistrycurrent,
        [this.state.quickfilterdatanew[4]]: this.state.ProjectLocationcurrent,
        [this.state.quickfilterdatanew[5]]: this.state
          .ImplementationModecurrent,
        [this.state.quickfilterdatanew[6]]: this.state.ProjectZonecurrent,
        offset: 0,
        limit: 10,
        ...extraParams,
        ...{ groupCategory: this.getGroupCategory() }
      });
    });
  };
  postFilterData6 = (
    value,
    filterName,
    isResponsive = false,
    isApplied = false
  ) => {
    const {
      props: {
        GET_PROJECT_LIST_ACTION,
        projectListReducer: { selectedFilters }
      },

      state: { temporaryFilters }
    } = this;
    let val = null;
    let currentFilter = isResponsive
      ? selectedFilters[filterName] || temporaryFilters[filterName]
      : selectedFilters[filterName];

    let extraParams = {};
    switch (filterName) {
      // in this case value is object
      case "sponsoringMinistry":
      case "sponsoringDepartment":
      case "projectScheme":
      case "sponsoringState":
      case "districtStateDept":
      case "recipientMinistry":
      case "projectStage":
      case "projectSector":
      case "projectTags":
      case "projectFlags":
      case "projectImplementationMode":
      case "recipientDistDept":
      case "projectProponent":
      case "bucket":
      case "milestone":
      case "bucketStatus":
      case "milestoneStatus":
      case "projectLocation":
      case "projectZones":
      case "districtProjectLocation":
        currentFilter = currentFilter || [];
        val = currentFilter.find(val => val.key === value.key);
        //console.log(currentFilter)
        //console.log(value)
        if (Array.isArray(value)) {
          if (value.length == 0) {
            currentFilter = value;
          } else {
            value.map(item => {
              !val
                ? currentFilter.push(item)
                : (currentFilter = currentFilter.filter(
                    val => val.key !== item.key
                  ));
            });
            var set = new Set();
            var results = [];
            //currentFilter=value
            for (let list of currentFilter) {
              let id = Object.values(list).join("");
              if (!set.has(id)) {
                set.add(id);
                results.push(list);
              }
            }
            currentFilter = results;
            currentFilter = value;
          }
        } else {
          !val
            ? currentFilter.push(value)
            : (currentFilter = currentFilter.filter(
                val => val.key !== value.key
              ));
        }

        break;

      case "projectCost":
      case "delayedProject":
      case "costOverRun":
        currentFilter = currentFilter || [];
        const { key } = value || {};
        const from = key.split("-")[0];
        const to = key.split("-")[1];

        if (isValidArray(currentFilter)) {
          const index = currentFilter.findIndex(value => {
            const { key } = value;
            return key.split("-")[0] === from && key.split("-")[1] === to;
          });

          index < 0
            ? currentFilter.push({ ...value, key: from + "-" + to })
            : currentFilter.splice(index, 1);
        } else {
          currentFilter.push({ ...value, key: from + "-" + to });
        }
        break;

      // In this case value is boolean
      case "pmg":
      case "pragatiReview":
        currentFilter = value.checked;
        break;

      case "search":
      case "createdDate":
        currentFilter = value;
        extraParams = { sortBy: null, sortOrder: null };
        break;

      default:
        break;
    }

    let filters = {
      ...selectedFilters,
      [filterName]: currentFilter,
      ...extraParams
    };
    let filterArr = [
      "sponsoringMinistry",
      "sponsoringDepartment",
      "sponsoringState",
      "districtStateDept",
      "projectStage",
      "projectCost",
      "stateProjectCost",
      "recipientMinistry",
      "recipientDistDept",
      "projectTags",
      "projectFlags",
      "projectSector",
      "projectImplementationMode",
      "projectProponent",
      "projectLocation",
      "projectZones",
      "districtProjectLocation"
    ];

    let test =
      Object.keys(filters) &&
      Object.keys(filters).length &&
      Object.keys(filters).some(function(e) {
        if (filterArr.includes(e)) {
          if (Array.isArray(filters[e])) {
            return filters[e].length;
          } else {
            return true;
          }
        }
      });

    if (!test) setLocalstorage("isSortClicked", false);
    if (selectedFilters.hasOwnProperty("projectStage")) {
      this.setState({ ProjectStagecurrent: selectedFilters.projectStage });
    }
    this.setState({ ImplementationModecurrent: currentFilter }, () => {
      GET_PROJECT_LIST_ACTION({
        ...selectedFilters,
        [this.state.quickfilterdatanew[0]]: this.state.Monitoringflagcurrent,
        [this.state.quickfilterdatanew[1]]: this.state.ProjectStatuscurrent,
        [this.state.quickfilterdatanew[2]]: this.state.ProjectStagecurrent,
        [this.state.quickfilterdatanew[3]]: this.state
          .ProjectSponsoringMinistrycurrent,
        [this.state.quickfilterdatanew[4]]: this.state.ProjectLocationcurrent,
        [this.state.quickfilterdatanew[5]]: this.state
          .ImplementationModecurrent,
        [this.state.quickfilterdatanew[6]]: this.state.ProjectZonecurrent,
        offset: 0,
        limit: 10,
        ...extraParams,
        ...{ groupCategory: this.getGroupCategory() }
      });
    });
  };
  postFilterData7 = (
    value,
    filterName,
    isResponsive = false,
    isApplied = false
  ) => {
    const {
      props: {
        GET_PROJECT_LIST_ACTION,
        projectListReducer: { selectedFilters }
      },

      state: { temporaryFilters }
    } = this;
    let val = null;
    let currentFilter = isResponsive
      ? selectedFilters[filterName] || temporaryFilters[filterName]
      : selectedFilters[filterName];

    let extraParams = {};
    switch (filterName) {
      // in this case value is object
      case "sponsoringMinistry":
      case "sponsoringDepartment":
      case "projectScheme":
      case "sponsoringState":
      case "districtStateDept":
      case "recipientMinistry":
      case "projectStage":
      case "projectSector":
      case "projectTags":
      case "projectFlags":
      case "projectZones":
      case "projectImplementationMode":
      case "recipientDistDept":
      case "projectProponent":
      case "bucket":
      case "milestone":
      case "bucketStatus":
      case "milestoneStatus":
      case "projectLocation":
      case "districtProjectLocation":
        currentFilter = currentFilter || [];
        val = currentFilter.find(val => val.key === value.key);
        //console.log(currentFilter)
        //console.log(value)
        if (Array.isArray(value)) {
          if (value.length == 0) {
            currentFilter = value;
          } else {
            value.map(item => {
              !val
                ? currentFilter.push(item)
                : (currentFilter = currentFilter.filter(
                    val => val.key !== item.key
                  ));
            });
            var set = new Set();
            var results = [];
            //currentFilter=value
            for (let list of currentFilter) {
              let id = Object.values(list).join("");
              if (!set.has(id)) {
                set.add(id);
                results.push(list);
              }
            }
            currentFilter = results;
            currentFilter = value;
          }
        } else {
          !val
            ? currentFilter.push(value)
            : (currentFilter = currentFilter.filter(
                val => val.key !== value.key
              ));
        }

        break;

      case "projectCost":
      case "delayedProject":
      case "costOverRun":
        currentFilter = currentFilter || [];
        const { key } = value || {};
        const from = key.split("-")[0];
        const to = key.split("-")[1];

        if (isValidArray(currentFilter)) {
          const index = currentFilter.findIndex(value => {
            const { key } = value;
            return key.split("-")[0] === from && key.split("-")[1] === to;
          });

          index < 0
            ? currentFilter.push({ ...value, key: from + "-" + to })
            : currentFilter.splice(index, 1);
        } else {
          currentFilter.push({ ...value, key: from + "-" + to });
        }
        break;

      // In this case value is boolean
      case "pmg":
      case "pragatiReview":
        currentFilter = value.checked;
        break;

      case "search":
      case "createdDate":
        currentFilter = value;
        extraParams = { sortBy: null, sortOrder: null };
        break;

      default:
        break;
    }

    let filters = {
      ...selectedFilters,
      [filterName]: currentFilter,
      ...extraParams
    };
    let projectZonesdata = currentFilter.map(e => {
      return e.key;
    });
    let filterArr = [
      "sponsoringMinistry",
      "sponsoringDepartment",
      "sponsoringState",
      "districtStateDept",
      "projectStage",
      "projectCost",
      "stateProjectCost",
      "recipientMinistry",
      "recipientDistDept",
      "projectTags",
      "projectFlags",
      "projectSector",
      "projectImplementationMode",
      "projectProponent",
      "projectLocation",
      "projectZones",
      "districtProjectLocation"
    ];

    let test =
      Object.keys(filters) &&
      Object.keys(filters).length &&
      Object.keys(filters).some(function(e) {
        if (filterArr.includes(e)) {
          if (Array.isArray(filters[e])) {
            return filters[e].length;
          } else {
            return true;
          }
        }
      });

    if (!test) setLocalstorage("isSortClicked", false);
    if (selectedFilters.hasOwnProperty("projectStage")) {
      this.setState({ ProjectStagecurrent: selectedFilters.projectStage });
    }
    //console.log(value);
    this.setState({ ProjectZonecurrent: currentFilter }, () => {
      GET_PROJECT_LIST_ACTION({
        ...selectedFilters,
        [this.state.quickfilterdatanew[0]]: this.state.Monitoringflagcurrent,
        [this.state.quickfilterdatanew[1]]: this.state.ProjectStatuscurrent,
        [this.state.quickfilterdatanew[2]]: this.state.ProjectStagecurrent,
        [this.state.quickfilterdatanew[3]]: this.state
          .ProjectSponsoringMinistrycurrent,
        [this.state.quickfilterdatanew[4]]: this.state.ProjectLocationcurrent,
        [this.state.quickfilterdatanew[5]]: this.state
          .ImplementationModecurrent,
        [this.state.quickfilterdatanew[6]]: this.state.ProjectZonecurrent,
        offset: 0,
        limit: 10,
        ...extraParams,
        ...{ groupCategory: this.getGroupCategory() }
      });
    });
  };
  applyResponsiveFilter = () => {
    const {
      props: { GET_PROJECT_LIST_ACTION },
      state: { temporaryFilters }
    } = this;
    GET_PROJECT_LIST_ACTION({
      ...temporaryFilters
    });
    this.filterClose();
  };

  onProjectListDownload = async () => {
    const {
      getDownloadProjectListAction,
      projectListReducer: { selectedFilters }
    } = this.props;
    const { includeMilestones } = this.state;
    let params = { ...selectedFilters, includeMilestones };
    await getDownloadProjectListAction(undefined, params);
    //await getDownloadProjectListAction(undefined, { ...selectedFilters });
  };

  onClearDownload = () => {
    const { clearProjectListDownloadAction } = this.props;
    clearProjectListDownloadAction();
  };
  onChangeIncludeMilestones = () => {
    this.setState(prevState => ({
      includeMilestones: !prevState.includeMilestones
    }));
  };
  getProjectStackeHolder = async () => {
    const {
      projectListReducer: { selectedFilters }
    } = this.props;
    return await getProjectStakeHolderAction(
      undefined,
      transformProjectListPayload(selectedFilters)
    );
  };

  onDateChange = ({ createdDate, dates }) => {
    this.postFilterData(createdDate, "createdDate");
    this.setState({ dates: { createdDate }, displayDateTitle: dates });
  };

  onSearch = e => {
    const { value } = e.target;
    this.setState({
      search: value,
      isSearching: true
    });
  };

  onLoadAfterSearch = () => {
    const { search } = this.state;
    this.setState(
      {
        isSearching: false
      },
      () => {
        this.postFilterData(search, "search");
      }
    );
  };

  onChangeSort = value => {
    const { sortBy, sortOrder } = value;
    const {
      props: {
        GET_PROJECT_LIST_ACTION,
        projectListReducer: { selectedFilters }
      }
    } = this;
    setLocalstorage("isSortClicked", true);
    GET_PROJECT_LIST_ACTION(
      {
        ...selectedFilters,
        sortBy,
        sortOrder,
        ...{ groupCategory: this.getGroupCategory() }
      },
      true
    );
  };

  onChangeArchive = value => {
    this.setState({ projectFilterTypeState: value.key });
    const {
      props: {
        GET_PROJECT_LIST_ACTION,
        projectListReducer: { selectedFilters }
      }
    } = this;
    let projectStagestatus = value.key == "ACTIVE" ? true : false;

    if (value.key == "ARCHIVED") {
      const filterRemove = this.state.QuickFilters.filter(
        val =>
          val.key !== "VERIFIED" &&
          val.key !== "ON_HOLD" &&
          val.key !== "CRIP_DRAFT" &&
          val.key !== "UNDER_VERIFICATION"
      );
      this.setState({ QuickFilters: filterRemove });

      const filterRemoveState = this.state.StateQuickFilters.filter(
        val =>
          val.key !== "VERIFIED" &&
          val.key !== "ON_HOLD" &&
          val.key !== "CRIP_DRAFT" &&
          val.key !== "UNDER_VERIFICATION"
      );
      if (this.getGroupCategory() == "STATE") {
        this.setState({ StateQuickFilters: filterRemoveState });
      }
    }
    if (value.key == "ALL") {
      const filterRemove = this.state.QuickFilters.filter(
        val => val.key !== "VERIFIED"
      );
      this.setState({ QuickFilters: filterRemove });

      const filterRemoveState = this.state.StateQuickFilters.filter(
        val => val.key !== "VERIFIED"
      );
      if (this.getGroupCategory() == "STATE") {
        this.setState({ StateQuickFilters: filterRemoveState });
      }
    }

    GET_PROJECT_LIST_ACTION(
      {
        ...selectedFilters,
        offset: 0,
        limit: 10,
        ...{ groupCategory: this.getGroupCategory() },
        projectFilterType: value.key,
        projectStage: projectStagestatus
          ? [
              ...(this.state.QuickFilters || []),
              {
                checked: true,
                displayName: "VERIFIED",
                filterName: "projectStage",
                key: "VERIFIED"
              }
            ]
          : []
      },
      true
    );
  };

  onProjectAwardedByChange = e => {
    const {
      GET_PROJECT_LIST_ACTION,
      getDashboardNotifications,
      getNotificationUpdates
    } = this.props;
    this.setState(
      {
        projectAwardedBy: e.target.checked,
        QuickFilters: [],
        StateQuickFilters: []
      },
      () => {
        getDashboardNotificationsAllViewed(
          undefined,
          this.getGroupCategory()
        ).then(resp => {
          // if (resp && resp.status) getDashboardNotifications();
          if (resp && resp.status) getNotificationUpdates();
        });
        GET_PROJECT_LIST_ACTION({
          ...{
            groupCategory: this.getGroupCategory(),
            projectFilterType: this.state.projectFilterTypeState || "ACTIVE"
          }
        });
      }
    );
  };

  onProjectAwardedByChangeResponsive = type => {
    const { GET_PROJECT_LIST_ACTION, getNotificationUpdates } = this.props;
    this.setState(
      {
        projectAwardedBy: type !== "CENTRAL"
      },
      () => {
        getDashboardNotificationsAllViewed(
          undefined,
          this.getGroupCategory()
        ).then(resp => {
          // if (resp && resp.status) getDashboardNotifications();
          if (resp && resp.status) getNotificationUpdates();
        });
        GET_PROJECT_LIST_ACTION({
          ...{
            groupCategory: this.getGroupCategory()
          }
        });
      }
    );
  };

  getGroupCategory = () => {
    return this.state.projectAwardedBy
      ? PROJECT_AWARDED_BY.STATE
      : PROJECT_AWARDED_BY.CENTRAL;
  };

  renderModalIIGCreateProjectDisabled = () => {
    return (
      <>
        <ModalIIGCreateProjectDisabled
          show={() =>
            this.setState({
              showModalForCreateProjectDisabled: true
            })
          }
          handleClose={() =>
            this.setState({
              showModalForCreateProjectDisabled: false
            })
          }
        />
      </>
    );
  };

  render() {
    const {
      props: {
        permission,
        projectListDownload,
        projectListReducer,
        notificationData,
        notifyStatusUpdateData,
        projectListReducerQuickfilter
      },
      state: {
        isSearching,
        search,
        projectAwardedBy,
        displayDateTitle,
        userGroupInfo
      },
      postFilterData,
      onLoadAfterSearch,
      onProjectListDownload,
      getProjectStackeHolder,
      onClearDownload,
      onDateChange,
      onChangeSort,
      onChangeArchive,
      onSearch,
      postFilterData1,
      postFilterData2,
      postFilterData3,
      postFilterData4,
      postFilterData5,
      postFilterData6,
      postFilterData7,
      postFilterData_State1,
      postFilterData_State2,
      postFilterData_State3,
      postFilterData_State4,
      postFilterData_State5,
      postFilterData_State6,
      postFilterData_State7,
      onChangeIncludeMilestones
    } = this;

    const {
      isLoading,
      data: projectListDTO,
      selectedFilters,
      bubbleFilters
    } = projectListReducer;
    // const hasReducerValuesChanged =
    //   this.state.isLoading !== isLoading ||
    //   this.state.projectListDTO !== projectListDTO;
    // // ... check other properties for changes

    // if (hasReducerValuesChanged) {
    //   const newFiltersData = [...this.state.QuickFilters];

    //   bubbleFilters.forEach(item => {
    //     for (const [filterName, filters] of Object.entries(item)) {
    //       filters.forEach(filter => {
    //         const existingFilterIndex = newFiltersData.findIndex(
    //           f => f.key === filter.key
    //         );

    //         if (existingFilterIndex === -1) {
    //           // Add filter only if it doesn't already exist
    //           newFiltersData.push({
    //             key: filter.key,
    //             displayName: filter.displayName,
    //             checked: true,
    //             filterName
    //           });
    //         }
    //       });
    //     }
    //   });
    //   const data = newFiltersData.filter(item => {
    //     return item.key !== undefined && item.displayName !== undefined;
    //   });
    //   //console.log(data);
    //   this.setState({
    //     isLoading,
    //     projectListDTO,
    //     selectedFilters,
    //     QuickFilters: data
    //   });
    // }

    //  remove limit and offset from filters
    // convert selected filters into array

    /* let isPwaVersion = document.getElementsByClassName("pwa-btn");
      let isPwaIconExist =
        isPwaVersion.length > 0 ? "issue-list-heading-pwa" : "";*/

    const groupCategory = this.getGroupCategory();

    let central, state;
    // if (notificationData && notificationData.data) {
    //   central =
    //     groupCategory !== "STATE" && groupCategory !== "STATE_PMG"
    //       ? 0
    //       : notificationData.data.central || 0;
    //   state =
    //     groupCategory === "STATE" || groupCategory === "STATE_PMG"
    //       ? 0
    //       : notificationData.data.state || 0;
    // }
    if (notifyStatusUpdateData && notifyStatusUpdateData) {
      central =
        groupCategory !== "STATE" && groupCategory !== "STATE_PMG"
          ? 0
          : notifyStatusUpdateData.central || 0;
      state =
        groupCategory === "STATE" || groupCategory === "STATE_PMG"
          ? 0
          : notifyStatusUpdateData.state || 0;
    }

    const user = getLocalstorage("user");
    const isUserPMG = getLocalstorage("groupCategory") === "PMG";

    return (
      <React.Fragment>
        {this.state.showModalForCreateProjectDisabled === true &&
          this.renderModalIIGCreateProjectDisabled()}
        <div className="content no-sidebar listpage-wrapper">
          <div className="container">
            <div className="common-list-heading-wrapper">
              <div className="common-list-heading-left">
                <h1 className="common-list-heading-text">
                  Project(s){" "}
                  {(get(projectListDTO, "total") && (
                    <span>({get(projectListDTO, "total")})</span>
                  )) ||
                    null}
                </h1>
                <div className="total-project-count">
                  <span>Project Cost :</span>
                  {get(projectListDTO, "totalCost") &&
                    formatNumberOnDashBoard(
                      get(projectListDTO, "totalCost"),
                      false
                    )}{" "}
                  Cr.
                </div>
              </div>
              <div className="common-list-heading-right">
                <DownloadExcelReport
                  isLoading={projectListDownload.isLoading}
                  downloadLink={projectListDownload.downloadingSrc}
                  onClearDownload={onClearDownload}
                  onStartDownloading={onProjectListDownload}
                />
                <Form.Check
                  type="checkbox"
                  label="Download with milestones"
                  className="download-check-box milestone-check"
                  onChange={onChangeIncludeMilestones}
                />
                {this.state.projectAwardedBy !== false ||
                user.groupCategory !== "STATE_PMG" ? (
                  <DisplayByPermission
                    display={get(permission, "customNotification")}
                  >
                    <SendByComponent
                      containerClass="send_notification"
                      getStakeHolders={getProjectStackeHolder}
                      notificationCO={{
                        projectFacetsCO: transformProjectListPayload(
                          selectedFilters
                        )
                      }}
                      permission={permission}
                      customNotificationType="PROJECT"
                      projectAwardedBy={this.getGroupCategory()}
                    />
                  </DisplayByPermission>
                ) : null}
                {/* {isUserPMG || isUserPP ? ( */}
                <DisplayByPermission
                  display={
                    get(permission, "createProject") &&
                    !get(permission, "canViewOnlyProject")
                  }
                >
                  {get(projectListDTO, "draftStatus") &&
                  get(projectListDTO, "draftStatus").drafted ? (
                    <div style={{ height: "47px" }}>
                      <Link
                        to={{
                          pathname: PATHS.CREATE_PROJECT,
                          state: { draftedProject: true }
                        }}
                      >
                        <Button className="btn-orange no-padding small-height create-btn">
                          Project Draft
                        </Button>
                      </Link>
                      <p className="saved-in-draft">
                        Modified On{" "}
                        <span className="draft-on">
                          {dateFormat(
                            get(projectListDTO, "draftStatus").draftedOn
                          )}
                        </span>
                      </p>
                    </div>
                  ) : isLoading === STATUS.SUCCESS &&
                    (get(permission, "createCentralProject") ||
                      get(permission, "createStateProject")) ? (
                    <Link to={PATHS.CREATE_PROJECT}>
                      <Button
                        className="btn-orange no-padding small-height create-btn"
                        data-test="project-tab-create-project-button"
                      >
                        Create Project
                      </Button>
                    </Link>
                  ) : (
                    <Button
                      className="btn-orange no-padding small-height create-btn"
                      onClick={() =>
                        this.setState({
                          showModalForCreateProjectDisabled: true
                        })
                      }
                    >
                      Create Project
                    </Button>
                  )}
                </DisplayByPermission>
                {/* ) : (
                    <Button
                      className="btn-orange no-padding small-height create-btn"
                      onClick={() =>
                        this.setState({
                          showModalForCreateProjectDisabled: true
                        })
                      }
                    >
                      Create Project
                    </Button>
                  )} */}
              </div>
            </div>
            <div
              className="common-list-content-wrapper"
              style={{
                marginTop:
                  get(projectListDTO, "draftStatus") &&
                  get(projectListDTO, "draftStatus").drafted
                    ? "0.5%"
                    : null
              }}
            >
              <div className="common-list-filter-wrapper">
                <h2>Sponsored Scheme</h2>
                <ToggleBtn
                  checked={projectAwardedBy}
                  callback={this.onProjectAwardedByChange}
                  central={central}
                  state={state}
                />
                <div className="sponser-toggle-wrapper">
                  <Button
                    className={`${
                      projectAwardedBy
                        ? "toggle-sponser-btn"
                        : "selected-sponser-btn"
                    }`}
                    onClick={() =>
                      this.onProjectAwardedByChangeResponsive("CENTRAL")
                    }
                  >
                    CENTRAL
                    {central ? (
                      <span>{central > 99 ? "99+" : central}</span>
                    ) : null}
                  </Button>
                  <Button
                    className={`${
                      projectAwardedBy
                        ? "selected-sponser-btn"
                        : "toggle-sponser-btn"
                    }`}
                    onClick={() =>
                      this.onProjectAwardedByChangeResponsive("STATE")
                    }
                  >
                    STATE
                    {state ? <span>{state > 99 ? "99+" : state}</span> : null}
                  </Button>
                </div>
                <Form>
                  <div className="issue-list-filters">
                    <div className="filter-header">
                      <div className="filter-title">
                        <Image src={IconFilter} alt="Filter Icon" />
                        <span>Filters</span>
                      </div>
                      {this.state.projectAwardedBy ? (
                        <StateProjectsQuickFilter
                          filtersValue={selectedFilters}
                          filterData={get(projectListDTO, "filters")}
                          staticFilterData={this.state.state_static_filter_data}
                          onChange1={postFilterData_State1}
                          onChange2={postFilterData_State2}
                          onChange3={postFilterData_State3}
                          onChange4={postFilterData_State4}
                          onChange5={postFilterData_State5}
                          onChange6={postFilterData_State6}
                          onChange7={postFilterData_State7}
                          onStateFilterChange={this.handleStateFilterChange}
                          onStateCloseChange={this.handleStateCloseChange}
                          checkedData={this.state.StateQuickFilters}
                        />
                      ) : (
                        // <>
                        //   {(bubbleFilters.length > 1 && (
                        //     <div
                        //       className="clear-filter"
                        //       onClick={this.clearAll}
                        //     >
                        //       Clear All
                        //     </div>
                        //   )) ||
                        //     null}
                        // </>
                        <>
                          {/*  Quick Filter Component Call start **/}

                          <QuickFilter
                            filtersValue={selectedFilters}
                            filterData={get(projectListDTO, "filters")}
                            staticFilterData={this.state.staticfilterdata}
                            onChange1={postFilterData1}
                            onChange2={postFilterData2}
                            onChange3={postFilterData3}
                            onChange4={postFilterData4}
                            onChange5={postFilterData5}
                            onChange6={postFilterData6}
                            onChange7={postFilterData7}
                            onFilterChange={this.handleFilterChange}
                            onCloseChange={this.handleCloseChange}
                            checkedData={this.state.QuickFilters}
                          />

                          {/*  Quick Filter Component Call End **/}
                        </>
                      )}
                      {/**{(bubbleFilters.length > 1 && (
                          
                          <div className="clear-filter" onClick={this.clearAll}>
                            Clear All
                            {console.log(bubbleFilters.length)}
                          </div>
                        )) ||
                          null} */}
                    </div>

                    {isLoading === STATUS.LOADING ? (
                      <LoaderTemplate
                        parentClass={"filter-loader-project-list"}
                        children={<FilterLoader />}
                        height={300}
                        width={400}
                      />
                    ) : (
                      <React.Fragment>
                        <FilterComponent
                          filtersValue={selectedFilters}
                          filterData={get(projectListDTO, "filters")}
                          onChange={postFilterData}
                        />
                      </React.Fragment>
                    )}
                  </div>
                </Form>
                <Form>
                  <div className="common-list-responsive-filters">
                    <div className="common-filter-header">
                      <div className="common-filter-title">
                        <span>Filters</span>
                      </div>
                      {(bubbleFilters.length > 1 && (
                        <div className="clear-filter" onClick={this.clearAll}>
                          CLEAR ALL
                        </div>
                      )) ||
                        null}
                    </div>

                    {isLoading === STATUS.LOADING ? (
                      <LoaderTemplate
                        parentClass={"filter-loader-project-list"}
                        children={<FilterLoader />}
                        height={90}
                      />
                    ) : (
                      <React.Fragment>
                        <ResponsiveFilter
                          filtersValue={selectedFilters}
                          filterData={get(projectListDTO, "filters")}
                          onChange={postFilterData}
                        />
                      </React.Fragment>
                    )}

                    <div className="common-filter-actions-wrapper">
                      <div onClick={this.filterClose}>Close</div>
                      {/*<div onClick={this.applyResponsiveFilter}>Apply</div>*/}
                    </div>
                  </div>
                </Form>
                <div className="close-filter" onClick={this.filterClose} />
              </div>
              <div className="common-list-multiple">
                <div className="common-list-exposed-filters">
                  <div className="filters-sections calender-filter-section">
                    <CalendarFilter
                      onChange={onDateChange}
                      calenderOptions={OTHER_CALENDER}
                      displayDateTitle={displayDateTitle}
                    />
                  </div>
                  <div className="filters-sections">
                    <Search
                      value={search}
                      isLoading={isSearching}
                      onChange={onSearch}
                      callAfterDebounce={onLoadAfterSearch}
                      placeholder="Search"
                    />
                  </div>
                  <div className="filters-sections sort-filter-wrapper">
                    <SortBy
                      sortBy={SORT_BY_FILTERS_LIST}
                      onChangeSort={onChangeSort}
                    />
                    <button className="filter-btn" onClick={this.filterOpen}>
                      <Image src={FilterIcon} alt="Filter Icon" />
                      Filters
                    </button>
                  </div>
                  <div className="filters-sections sort-filter-wrapper">
                    <Archive
                      sortBy={archiveDropdown}
                      onChangeArchive={onChangeArchive}
                    />
                  </div>
                </div>
                {this.state.projectAwardedBy ? (
                  <>
                    {/**For State Section Starts */}
                    <div className="applied-filter-list">
                      {this.state.StateQuickFilters.length == 0 ? null : (
                        <>
                          {this.state.StateQuickFilters.map(
                            (element, index) => (
                              <div className="applied-filter" key={index}>
                                {element.displayName ===
                                "PHYSICALLY_COMPLETED" ? (
                                  <>PHYSICALLY COMPLETED/CC UNDER ISSUE</>
                                ) : (
                                  <>{element.displayName}</>
                                )}
                                <span
                                  className="close"
                                  onClick={e => {
                                    this.handleStateCheckbox(
                                      element,
                                      element.filterName
                                    );
                                  }}
                                >
                                  X
                                </span>
                              </div>
                            )
                          )}
                        </>
                      )}
                      {this.state.StateQuickFilters.length > 1 ? (
                        <div
                          className="clear-filter-new"
                          onClick={this.clearAll}
                        >
                          Clear All
                        </div>
                      ) : null}
                    </div>

                    {/**For State Section End */}
                  </>
                ) : (
                  <>
                    {/**For Central Section Starts */}
                    <div className="applied-filter-list">
                      {this.state.QuickFilters.length == 0 ? null : (
                        <>
                          {this.state.QuickFilters.map((element, index) => (
                            <div className="applied-filter" key={index}>
                              {element.displayName ===
                              "PHYSICALLY_COMPLETED" ? (
                                <>PHYSICALLY COMPLETED/CC UNDER ISSUE</>
                              ) : (
                                <>{element.displayName}</>
                              )}
                              <span
                                className="close"
                                onClick={e => {
                                  this.handleCheckbox1(
                                    element,
                                    element.filterName
                                  );
                                }}
                              >
                                X
                              </span>
                            </div>
                          ))}
                        </>
                      )}

                      {/**New Code For Clear All Functionality Start */}
                      {this.state.QuickFilters.length > 1 ? (
                        <div
                          className="clear-filter-new"
                          onClick={this.clearAll}
                        >
                          Clear All
                        </div>
                      ) : null}

                      {/**New Code For Clear All Functionality End */}
                    </div>
                    {/**For Central Section Ends */}
                  </>
                )}

                {get(projectListDTO, "listDTO") &&
                (selectedFilters && selectedFilters.offset > 0) ? (
                  <div className="add-space">
                    <Pagination
                      offset={selectedFilters.offset}
                      pageCount={
                        get(projectListDTO, "total", 0) /
                        get(projectListDTO, "limit", 0)
                      }
                      onPageChange={this.onPageChange}
                    />
                  </div>
                ) : null}
                <ProjectListLoader
                  projectList={get(projectListDTO, "listDTO")}
                  isLoading={isLoading}
                />
                {get(projectListDTO, "listDTO") ? (
                  <Pagination
                    offset={selectedFilters.offset}
                    pageCount={
                      get(projectListDTO, "total", 0) /
                      get(projectListDTO, "limit", 0)
                    }
                    onPageChange={this.onPageChange}
                  />
                ) : null}
              </div>
            </div>
          </div>
        </div>
      </React.Fragment>
    );
  }
  // extract from this
}

function mapStateToProps(state) {
  const {
    commonReducer: { projectList, status },
    donwloadExcelReducer: { projectListDownload },
    dashboardReducer: { notificationData, notifyStatusUpdateData }
  } = state;
  return {
    projectListDownload,
    projectList,
    status,
    notificationData,
    notifyStatusUpdateData
  };
}

function mapDispatchToProps(dispatch) {
  return bindActionCreators(
    {
      getDownloadProjectListAction,
      clearProjectListDownloadAction,
      GET_PROJECT_LIST_ACTION,
      CLEAR_ISSUE_OLD_FILTERS_ACTION,
      getDraftedProjectDetails,
      getDashboardNotifications,
      getNotificationUpdates
    },
    dispatch
  );
}

export default connect(
  mapStateToProps,
  mapDispatchToProps
)(PermissionHOC(ProjectListHoc(ProjectList)));
